import React, { useState, useEffect, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { IoClose, IoCar } from "react-icons/io5";
import {
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaCarSide,
  FaMoneyBillWave,
  FaUser,
  FaCreditCard,
} from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import { cars, coupons, rentals, locations, additionalOptions, oxygen } from "../../services/api"; // Added additionalOptions
import moment from "moment";
import "moment-timezone";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import OpelCorsa from "../../assets/images/opelcorsa.jpg";
import SpaceStar from "../../assets/images/MITS-SPACE.png";
import Peugeot208 from "../../assets/images/p-208.jpg";
import Peugeot108 from "../../assets/images/108-p.webp";
import CitroenC1 from "../../assets/images/C1.jpeg";
import Micra from "../../assets/images/PHOTO-2022-01-23-14-12-06.jpg";
import Panda from "../../assets/images/PHOTO-2022-01-23-14-12-05-1.jpg";
import Stonic from "../../assets/images/KIA-STONIC-Manual-1.png";
import i20 from "../../assets/images/HYUNDAI-i20-Manual-1.png";
import quashqai from "../../assets/images/quashqai.jpg";
import duster from "../../assets/images/duster.jpeg";
import crossland from "../../assets/images/opel-crossland.webp";
import clio from "../../assets/images/RENAULT-CLIO-Manual-1.png";
import rio from "../../assets/images/KIA-RIO-Auto-1.png";
import Wrangler5D from "../../assets/images/jeep-wr-5d.png";
import WranglerCabrio from "../../assets/images/Jeep-wrangler-cabrio.png";
import Discovery from "../../assets/images/land-rover.webp";
import Wrangler from "../../assets/images/JEEP-WRANGLER-Auto-1.png";
import WranglerSahara from "../../assets/images/JEEP-WRANGLER-1.png.webp";
import Berlingo from "../../assets/images/CITROEN-BERLINGO-Auto.png.webp";
import Doblo from "../../assets/images/FIAT-DOBLO-Manual-1.png.webp";
import TRoc from "../../assets/images/vw-t-roc.png";
import C1Cabrio from "../../assets/images/PHOTO-2022-01-23-14-12-11.jpg.webp";
import MiniCooper from "../../assets/images/MINI-COOPER-Cabrio-Auto-1.png.webp";
import Fiat500 from "../../assets/images/FIAT-500-Auto-Cabrio-1.png.webp";
import SmartForTwo from "../../assets/images/SMART-ForTwo-Cabrio-Manual-4.png.webp";
import SmartForTwoAuto from "../../assets/images/SMART-ForTwo-Cabrio-Auto-2.png.webp";
import Buggy800 from "../../assets/images/CF-MOTO-BUGGY-800cc-1.png.webp";
import Buggy550 from "../../assets/images/CF-MOTO-BUGGY-550cc-1.png.webp";
import ATV450 from "../../assets/images/5_14f72470629695dca3487f902b2c012f.png.webp";
import RangeSport from "../../assets/images/PHOTO-2022-01-22-12-09-42.jpg";
import C3Aircross from "../../assets/images/PHOTO-2022-01-25-15-13-22.jpg";
import C3 from "../../assets/images/PHOTO-2022-01-22-11-45-44-1.jpg";
import C4Cactus from "../../assets/images/PHOTO-2022-01-22-11-51-47.jpg";
import MiniCountryman from "../../assets/images/PHOTO-2022-01-25-15-13-22-1.jpg";
import Glb2022 from "../../assets/images/MERCEDES-BENZ-GLB-2022-Automatic-1.png";
import Gla2023 from "../../assets/images/253_9060274dbdc76eb56b4a456a70298fff.png";
import BmwX1 from "../../assets/images/BMW-X1-2023-Automatic.png";
import BmwX2 from "../../assets/images/BMW-X2-Automatic-1.png";
import Sportage from "../../assets/images/KIA-SPORTAGE-Auto-1.png";
import Picanto from "../../assets/images/picanto.jpg";
import Cayenne from "../../assets/images/PORSCHE-CAYENNE-Auto-1.png";
import Bike125 from "../../assets/images/125bike.png";
import logo from "../../assets/images/logo-1.png";

// --- Image Map ---
const imageMap = {
  "opelcorsa.jpg": OpelCorsa,
  "MITS-SPACE.png": SpaceStar,
  "p-208.jpg": Peugeot208,
  "108-p.webp": Peugeot108,
  "C1.jpeg": CitroenC1,
  "PHOTO-2022-01-23-14-12-06.jpg": Micra,
  "PHOTO-2022-01-23-14-12-05-1.jpg": Panda,
  "KIA-STONIC-Manual-1.png": Stonic,
  "HYUNDAI-i20-Manual-1.png": i20,
  "quashqai.jpg": quashqai,
  "duster.jpeg": duster,
  "opel-crossland.webp": crossland,
  "RENAULT-CLIO-Manual-1.png": clio,
  "KIA-RIO-Auto-1.png": rio,
  "jeep-wr-5d.png": Wrangler5D,
  "Jeep-wrangler-cabrio.png": WranglerCabrio,
  "land-rover.webp": Discovery,
  "JEEP-WRANGLER-Auto-1.png": Wrangler,
  "JEEP-WRANGLER-1.png.webp": WranglerSahara,
  "CITROEN-BERLINGO-Auto.png.webp": Berlingo,
  "FIAT-DOBLO-Manual-1.png.webp": Doblo,
  "vw-t-roc.png": TRoc,
  "PHOTO-2022-01-23-14-12-11.jpg.webp": C1Cabrio,
  "MINI-COOPER-Cabrio-Auto-1.png.webp": MiniCooper,
  "FIAT-500-Auto-Cabrio-1.png.webp": Fiat500,
  "SMART-ForTwo-Cabrio-Manual-4.png.webp": SmartForTwo,
  "SMART-ForTwo-Cabrio-Auto-2.png.webp": SmartForTwoAuto,
  "CF-MOTO-BUGGY-800cc-1.png.webp": Buggy800,
  "beach_buggy.png": Buggy550, // Assuming this maps to Buggy550
  "5_14f72470629695dca3487f902b2c012f.png.webp": ATV450,
  "PHOTO-2022-01-22-12-09-42.jpg": RangeSport,
  "PHOTO-2022-01-25-15-13-22.jpg": C3Aircross,
  "PHOTO-2022-01-22-11-45-44-1.jpg": C3,
  "PHOTO-2022-01-22-11-51-47.jpg": C4Cactus,
  "PHOTO-2022-01-25-15-13-22-1.jpg": MiniCountryman,
  "MERCEDES-BENZ-GLB-2022-Automatic-1.png": Glb2022,
  "253_9060274dbdc76eb56b4a456a70298fff.png": Gla2023,
  "BMW-X1-2023-Automatic.png": BmwX1,
  "BMW-X2-Automatic-1.png": BmwX2,
  "KIA-SPORTAGE-Auto-1.png": Sportage,
  "PORSCHE-CAYENNE-Auto-1.png": Cayenne,
  "125bike.png": Bike125,
  "picanto.jpg": Picanto,
};

// --- getImage function ---
const getImage = (imagePath) => {
  if (!imagePath) return null;
  if (typeof imagePath === "string") {
    if (imagePath.startsWith("/images/")) {
      const filename = imagePath.split("/").pop();
      return imageMap[filename] || imagePath; // Fallback to original path if not in map
    }
    const filename = imagePath.split("/").pop();
    return imageMap[filename] || imagePath; // Fallback for static imports
  }
  return imagePath; // Should not happen if data is consistent
};

const CreateRentalModal = ({ isOpen, onClose, onSuccess, isPartnerMode = false, partner = null }) => {
  // --- State Declarations ---
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [availableCars, setAvailableCars] = useState([]);
  const [selectedCar, setSelectedCar] = useState(null);
  const [selectedCarDetails, setSelectedCarDetails] = useState(null);
  const [datePickerOpen, setDatePickerOpen] = useState({
    pickup: false,
    dropoff: false,
  });
  const [dateTimeComplete, setDateTimeComplete] = useState({
    pickup: false,
    dropoff: false,
  });
  const [timeWarnings, setTimeWarnings] = useState({
    pickup: false,
    dropoff: false,
  });
  const [availabilityData, setAvailabilityData] = useState(null);
  const [couponStatus, setCouponStatus] = useState({
    isValid: false,
    discount: 0,
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [totalPrice, setTotalPrice] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [durationDiscounts, setDurationDiscounts] = useState({
    shortTerm: { discount: 0 },
    mediumTerm: { discount: 5 },
    longTerm: { discount: 10 },
  });
  const [additionalOptionsData, setAdditionalOptionsData] = useState([]);
  const [loadingAdditionalOptions, setLoadingAdditionalOptions] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [loadingPaymentMethods, setLoadingPaymentMethods] = useState(false);

  // Add invoice state
  const [wantsInvoice, setWantsInvoice] = useState(false);
  const [invoiceData, setInvoiceData] = useState({
    companyName: "",
    vatNumber: "",
    address: "",
    city: "",
    postalCode: "",
    country: "Greece"
  });
  const [formData, setFormData] = useState({
    pickupDate: null,
    dropoffDate: null,
    pickupLocation: "",
    dropoffLocation: "",
    customPickupLocation: isPartnerMode && partner ? partner.firstName : "",
    customDropoffLocation: isPartnerMode && partner ? partner.firstName : "",
    email: "",
    phone: "",
    age: "26+",
    additionalOptions: {}, // Changed from hardcoded to empty object
    couponCode: "",
    notes: "",
    customPricePerDay: "",
    advancePayment: "",
    paymentMethod: "",
  });

  const [sameLocation, setSameLocation] = useState(true);

  // --- Location Options ---
const defaultLocationOptions = [
    { value: "airport", label: "Airport of Mykonos (JMK)" },
    { value: "central", label: "Mykonos Central Office" },
    { value: "new-port", label: "Mykonos New Port (Tourlos)" },
    { value: "old-port", label: "Mykonos Old Port" },
    { value: "hotel", label: "Hotel / Apartment / Villa" },
    { value: "other", label: "Other Location (Hotel/Restaurant/Beach)" },
  ];
  
  // State for location options from API
  const [locationOptions, setLocationOptions] = useState(defaultLocationOptions);
  
  // Fetch locations when component mounts
  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const response = await locations.getActive();
        
        if (response && Array.isArray(response)) {
          // Map API locations to the format expected by the component
          const apiLocations = response.map(location => ({
            value: location._id,
            label: location.name
          }));
          
          // Always add "other" option
          apiLocations.push(
            { value: "other", label: "Other Location (Hotel/Restaurant/Beach)" }
          );
          
          setLocationOptions(apiLocations);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
        // Keep using the default locations if API fails
      }
    };
    
    fetchLocations();
  }, []);

  // --- Fetch Initial Data on Modal Open ---
  useEffect(() => {
    if (isOpen) {
      fetchCars();
      fetchDurationDiscounts();
      fetchAdditionalOptions();
      fetchPaymentMethods();
    } else {
      resetForm();
    }
  }, [isOpen]);

  // --- Fetch Duration Discounts ---
  const fetchDurationDiscounts = async () => {
    try {
      const response = await rentals.getDurationDiscounts();
      setDurationDiscounts(response.data);
    } catch (error) {
      console.error("Error fetching duration discounts:", error);
      // Keep default discounts if fetch fails
    }
  };

  // --- Fetch Additional Options (MODIFIED) ---
  const fetchAdditionalOptions = async () => {
    setLoadingAdditionalOptions(true);
    try {
      const options = await additionalOptions.getActive();
      
      if (options && Array.isArray(options)) {
        setAdditionalOptionsData(options);
        
        // Initialize formData.additionalOptions with all options set to false
        const initializedOptions = {};
        options.forEach(option => {
          initializedOptions[option._id] = false;
        });
        
        setFormData(prev => ({
          ...prev,
          additionalOptions: initializedOptions
        }));
      } else {
        // Fallback to default options if API fails
        const defaultOptions = [
          { _id: "default-child-seat", name: "Child Seat", description: "Add a Child Seat to your Vehicle!", price: 0, isEnabled: true },
          { _id: "default-baby-chair", name: "Baby Chair", description: "Add a Baby Chair to your Vehicle!", price: 0, isEnabled: true },
          { _id: "default-gps", name: "GPS", description: "Navigation system for your journey", price: 0, isEnabled: true }
        ];
        setAdditionalOptionsData(defaultOptions);
        
        const initializedOptions = {};
        defaultOptions.forEach(option => {
          initializedOptions[option._id] = false;
        });
        
        setFormData(prev => ({
          ...prev,
          additionalOptions: initializedOptions
        }));
      }
    } catch (error) {
      console.error("Error fetching additional options:", error);
      // Fallback to default options
      const defaultOptions = [
        { _id: "default-child-seat", name: "Child Seat", description: "Add a Child Seat to your Vehicle!", price: 0, isEnabled: true },
        { _id: "default-baby-chair", name: "Baby Chair", description: "Add a Baby Chair to your Vehicle!", price: 0, isEnabled: true },
        { _id: "default-gps", name: "GPS", description: "Navigation system for your journey", price: 0, isEnabled: true }
      ];
      setAdditionalOptionsData(defaultOptions);
      
      const initializedOptions = {};
      defaultOptions.forEach(option => {
        initializedOptions[option._id] = false;
      });
      
      setFormData(prev => ({
        ...prev,
        additionalOptions: initializedOptions
      }));
    } finally {
      setLoadingAdditionalOptions(false);
    }
  };

  // --- Fetch Payment Methods ---
  const fetchPaymentMethods = async () => {
    setLoadingPaymentMethods(true);
    try {
      const response = await oxygen.getPaymentMethods();
      
      if (response && response.data) {
        setPaymentMethods(response.data);
      } else {
        console.error("Invalid payment methods response:", response);
      }
    } catch (error) {
      console.error("Error fetching payment methods:", error);
    } finally {
      setLoadingPaymentMethods(false);
    }  };

  // --- Reset Form State ---
  const resetForm = () => {
    setFormData({
      pickupDate: null,
      dropoffDate: null,
      pickupLocation: "",
      dropoffLocation: "",
      customPickupLocation: "",
      customDropoffLocation: "",
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      age: "26+",
      additionalOptions: {}, // Reset to empty object
      couponCode: "",
      notes: "",
      customPricePerDay: "",
      advancePayment: "",
      paymentMethod: "",
    });
    setSameLocation(true);
    setSelectedCar(null);
    setSelectedCarDetails(null);
    setAvailabilityData(null);
    setCouponStatus({ isValid: false, discount: 0, message: "" });
    setErrors({});
    setTotalPrice(0);
    setDatePickerOpen({ pickup: false, dropoff: false });
    setDateTimeComplete({ pickup: false, dropoff: false });
    setTimeWarnings({ pickup: false, dropoff: false });
    setSearchQuery("");
    setSelectedCategory("");
    setAdditionalOptionsData([]); // Reset fetched options
    setLoadingAdditionalOptions(false); // Reset loading state
    
    // Reset invoice state
    setWantsInvoice(false);
    setInvoiceData({
      companyName: "",
      vatNumber: "",
      address: "",
      city: "",
      postalCode: "",
      country: "Greece"
    });
  };

  // --- Fetch Available Cars ---
  const fetchCars = async () => {
    try {
      setInitialLoading(true);
      const response = await cars.getAll(); // Assuming this fetches all cars
      // Filter for available cars on the client-side
      setAvailableCars(
        response.data.filter((car) => car.status === "available")
      );
    } catch (error) {
      console.error("Error fetching cars:", error);
      setErrors(prev => ({ ...prev, car: "Failed to load cars." }));
    } finally {
      setInitialLoading(false);
    }
  };


  // --- Fetch Car Details ---
  const fetchCarDetails = async (carId) => {
    try {
      const response = await cars.getById(carId);
      setSelectedCarDetails(response.data);
    } catch (error) {
      console.error("Error fetching car details:", error);
    }
  };

  // --- Handle Car Selection ---
  const handleCarSelect = (car) => {
    setSelectedCar(car);
    if (isPartnerMode) {
      fetchCarDetails(car._id); // Fetch detailed car information for partner mode
    }
    fetchInitialPricing(car.category, car.stringId); // Fetch dynamic prices for the selected car
     // Clear car selection error if present
    setErrors(prev => ({ ...prev, car: undefined }));
  };

  // --- Fetch Initial/Dynamic Pricing for Selected Car ---
  const fetchInitialPricing = async (category, stringId) => {
    // Fetch dynamic prices for the current/next month initially
    try {
      const today = new Date();
      // Fetch for a range, e.g., current and next month
      const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
      const monthEnd = new Date(today.getFullYear(), today.getMonth() + 2, 0); // End of next month

      const response = await cars.getAvailable({
        startDate: monthStart.toISOString(),
        endDate: monthEnd.toISOString(),
        category: category,
                includeAll: true, // Include all cars in the category

      });

      // Find the specific car's availability data
      const carAvailability = response.data.find((c) => c.stringId === stringId)?.availability || [];
      setAvailabilityData({ dynamicPrices: carAvailability });

    } catch (error) {
      console.error("Error fetching initial pricing:", error);
      setAvailabilityData({ dynamicPrices: [] }); // Set empty array on error
    }
  };

  // --- Handle DatePicker Month Change ---
  const handleMonthChange = async (date) => {
    if (!selectedCar) return;

    // Fetch dynamic pricing for the newly visible month
    try {
      const monthStart = new Date(date.getFullYear(), date.getMonth(), 1);
      const monthEnd = new Date(date.getFullYear(), date.getMonth() + 1, 0);

      const response = await cars.getAvailable({
        startDate: monthStart.toISOString(),
        endDate: monthEnd.toISOString(),
        category: selectedCar.category,
        includeAll: true, // Include all cars in the category
      });

      const carAvailability = response.data.find((c) => c.stringId === selectedCar.stringId)?.availability || [];
      // OPTIONAL: Merge with existing data or replace? Replacing might be simpler.
      setAvailabilityData({ dynamicPrices: carAvailability });

    } catch (error) {
      console.error("Error fetching pricing for month:", error);
    }
  };

  // --- Validate Dates ---
  const validateDates = (newDate, type) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Compare dates only

    const pickupErrorKey = 'pickupDate';
    const dropoffErrorKey = 'dropoffDate';

    let isValid = true;
    let newErrors = { ...errors }; // Copy existing errors

    if (type === "pickupDate") {
       if (formData.dropoffDate && newDate >= formData.dropoffDate) { // Use >= to prevent same day/time issues
        newErrors[pickupErrorKey] = "Pick-up must be before drop-off";
        // Also potentially set dropoff error if pickup makes it invalid
        newErrors[dropoffErrorKey] = "Drop-off must be after pick-up";
        isValid = false;
      } else {
        delete newErrors[pickupErrorKey]; // Clear error if valid
        // If pickup is now valid, re-evaluate dropoff validity
        if (formData.dropoffDate && newDate >= formData.dropoffDate) {
             newErrors[dropoffErrorKey] = "Drop-off must be after pick-up";
        } else {
             delete newErrors[dropoffErrorKey];
        }
      }
    } else if (type === "dropoffDate") {
      if (formData.pickupDate && newDate <= formData.pickupDate) { // Use <=
        newErrors[dropoffErrorKey] = "Drop-off must be after pick-up";
         // Also potentially set pickup error
         newErrors[pickupErrorKey] = "Pick-up must be before drop-off";
        isValid = false;
      } else {
        delete newErrors[dropoffErrorKey]; // Clear error if valid
         // If dropoff is now valid, re-evaluate pickup validity
         if (formData.pickupDate && newDate <= formData.pickupDate) {
             newErrors[pickupErrorKey] = "Pick-up must be before drop-off";
         } else {
             delete newErrors[pickupErrorKey];
         }
      }
    }

    setErrors(newErrors); // Update errors state
    return isValid;
  }


  // --- Handle Date Selection ---
  const handleDateChange = (date, type) => {
     // Basic validation first
     if (!validateDates(date, type)) {
       // Keep the DatePicker open if validation fails immediately?
       // Or let the error message guide the user.
       // For now, just return to prevent setting invalid date.
       return;
     }


    const isPickup = type === "pickupDate";
    const stateKey = isPickup ? "pickup" : "dropoff";

    // Check if time part is selected (assuming 00:00 means time not selected yet)
    // Allow 00:00 if explicitly selected by user? Need clarification.
    // For now, assume any time other than midnight start means time is set.
    const hasTime = date && (date.getHours() !== 0 || date.getMinutes() !== 0);

    setDateTimeComplete((prev) => ({ ...prev, [stateKey]: hasTime }));
    setTimeWarnings((prev) => ({ ...prev, [stateKey]: !hasTime })); // Show warning if no time

    setFormData((prev) => ({ ...prev, [type]: date }));

    // Close picker only if time is selected
    if (hasTime) {
      setDatePickerOpen((prev) => ({
        ...prev,
        [stateKey]: false,
        // Smartly open the next picker if needed
        ...(isPickup && !formData.dropoffDate ? { dropoff: true } : {}), // Open dropoff if pickup set & dropoff empty
      }));
       // Clear the specific date error upon successful selection with time
       setErrors(prev => ({ ...prev, [type]: undefined }));
    } else {
       // Keep the picker open if only date is selected
       setDatePickerOpen((prev) => ({ ...prev, [stateKey]: true }));
    }
  };

  // --- Calculate Price Breakdown (MODIFIED for Custom Price) ---
  const calculatePriceBreakdown = useCallback(() => {
    if (!formData.pickupDate || !formData.dropoffDate || !selectedCar) {
      return null;
    }

    const breakdown = [];
    // Use the exact pickup time
    let currentDate = new Date(formData.pickupDate);
    // Clone end date to avoid modifying the original state date
    const endDate = new Date(formData.dropoffDate);

    // Use custom price if it's set and valid
    const customPriceStr = formData.customPricePerDay;
    const customPrice = customPriceStr !== "" && customPriceStr !== null && customPriceStr !== undefined
      ? parseFloat(customPriceStr)
      : null;

    // Only consider custom price valid if it's a positive number
    const isCustomPriceValid = customPrice !== null && !isNaN(customPrice) && customPrice > 0;

    // Keep original pickup and dropoff times for calculating if the last day is complete
    const exactPickupDate = new Date(currentDate);
    const exactDropoffDate = new Date(endDate);
    
    // Reset time for date-based comparisons in the loop
    let loopCurrentDate = new Date(currentDate);
    loopCurrentDate.setHours(0, 0, 0, 0);
    
    const loopEndDate = new Date(endDate);
    loopEndDate.setHours(23, 59, 59, 999); // End of day for comparison

    while (loopCurrentDate <= loopEndDate) {
      const dateString = loopCurrentDate.toDateString();

      // Get dynamic price if available and no valid custom price is set
      const dynamicPriceData = !isCustomPriceValid
        ? availabilityData?.dynamicPrices?.find(
            (p) => new Date(p.date).toDateString() === dateString
          )
        : null;

      // Determine price for the day (custom > dynamic > base)
      let price = selectedCar.basePrice; // Default to base
      if (isCustomPriceValid) {
        price = customPrice; // Use custom if valid
      } else if (dynamicPriceData?.dynamicPrice) {
        price = dynamicPriceData.dynamicPrice; // Use dynamic if available
      }

      // Try to merge with previous period if same price
      const lastEntry = breakdown.length > 0 ? breakdown[breakdown.length - 1] : null;
      if (lastEntry && lastEntry.price === price && lastEntry.endDate.toDateString() === new Date(loopCurrentDate.getTime() - 86400000).toDateString()) {
        // If this is the same price and consecutive day, extend previous period
        lastEntry.days++;
        lastEntry.endDate = new Date(loopCurrentDate);
      } else {
        // Start new period
        breakdown.push({
          startDate: new Date(loopCurrentDate),
          endDate: new Date(loopCurrentDate),
          price,
          days: 1,
        });
      }

      // Move to next day
      loopCurrentDate = new Date(loopCurrentDate.setDate(loopCurrentDate.getDate() + 1));
    }

    // Adjust for partial days based on actual pickup and dropoff times
    // If the dropoff time is earlier than pickup time on the same day,
    // we should not charge for a full day
    if (breakdown.length > 0) {
      const lastPeriod = breakdown[breakdown.length - 1];
      const lastDayStart = new Date(lastPeriod.endDate);
      lastDayStart.setHours(0, 0, 0, 0);
      
      // If dropoff is on the same day as the last day in our breakdown
      if (lastDayStart.toDateString() === exactDropoffDate.toDateString()) {
        // Compare pickup and dropoff times with exact precision
        const pickupTime = exactPickupDate.getHours() * 60 + exactPickupDate.getMinutes();
        const dropoffTime = exactDropoffDate.getHours() * 60 + exactDropoffDate.getMinutes();
        
        // If times are exactly equal or dropoff time is earlier than pickup time
        if (dropoffTime < pickupTime || dropoffTime === pickupTime) {
          if (lastPeriod.days === 1) {
            // If this period has only one day, remove it
            breakdown.pop();
          } else {
            // Reduce the number of days and adjust end date
            lastPeriod.days--;
            const newEndDate = new Date(lastPeriod.endDate);
            newEndDate.setDate(newEndDate.getDate() - 1);
            lastPeriod.endDate = newEndDate;
          }
        }
      }
    }

    return breakdown;
  }, [
    formData.pickupDate,
    formData.dropoffDate,
    selectedCar,
    availabilityData,
    formData.customPricePerDay
  ]);

  // --- Calculate Total Price (Base, before VAT/Coupon) (MODIFIED for Additional Options) ---
  const calculateBaseTotalPrice = useCallback(() => {
    if (!formData.pickupDate || !formData.dropoffDate) {
      return selectedCar?.dynamicPrice || selectedCar?.basePrice || 0;
    }

    const breakdown = calculatePriceBreakdown();
    if (!breakdown) return selectedCar?.dynamicPrice || selectedCar?.basePrice || 0;

    const subtotal = breakdown.reduce(
      (total, period) => total + period.price * period.days,
      0
    );

    const totalDays = calculateDurationIn24HourDays(formData.pickupDate, formData.dropoffDate);

    // Apply duration-based discounts
    let discountPercentage = 0;
    if (totalDays > 10) {
      discountPercentage = durationDiscounts.longTerm.discount;
    } else if (totalDays > 3) {
      discountPercentage = durationDiscounts.mediumTerm.discount;
    } else {
      discountPercentage = durationDiscounts.shortTerm.discount;
    }

    const durationDiscount = (subtotal * discountPercentage) / 100;
    
    // Calculate the cost of additional options
    let additionalOptionsCost = 0;
    if (additionalOptionsData.length > 0 && formData.additionalOptions) {
      additionalOptionsData.forEach(option => {
        if (formData.additionalOptions[option._id]) {
          additionalOptionsCost += option.price * totalDays;
        }
      });
    }
    
    return subtotal - durationDiscount + additionalOptionsCost;
  }, [
    formData.pickupDate,
    formData.dropoffDate,
    selectedCar,
    durationDiscounts,
    calculatePriceBreakdown,
    formData.additionalOptions,
    additionalOptionsData,
  ]);

  // Add the calculateDurationIn24HourDays function
  const calculateDurationIn24HourDays = (pickupDateStr, dropoffDateStr) => {
    if (!pickupDateStr || !dropoffDateStr) {
      return 0;
    }

    const pickupDate = new Date(pickupDateStr);
    const dropoffDate = new Date(dropoffDateStr);

    // Check for invalid date strings or objects
    if (isNaN(pickupDate.getTime()) || isNaN(dropoffDate.getTime())) {
      console.error("Invalid date provided for duration calculation.");
      return 0;
    }

    if (dropoffDate <= pickupDate) {
      if (dropoffDate.getTime() === pickupDate.getTime()) {
        return 0; 
      }
      // If dropoffDate < pickupDate, it's an invalid range, return 0
      if (dropoffDate < pickupDate) {
        return 0;
      }
    }

    const diffTime = dropoffDate.getTime() - pickupDate.getTime(); // Difference in milliseconds

    if (diffTime < 0) {
      return 0;
    }

    const millisecondsPerDay = 1000 * 60 * 60 * 24;
    
    // Get the exact time components in minutes since midnight
    const pickupMinutes = pickupDate.getHours() * 60 + pickupDate.getMinutes();
    const dropoffMinutes = dropoffDate.getHours() * 60 + dropoffDate.getMinutes();
    
    // Calculate full days between dates
    const fullDays = Math.floor(diffTime / millisecondsPerDay);
    
    // Only add an extra day if the dropoff time is STRICTLY later than the pickup time
    // This ensures that exact same times don't add an extra day
    let extraDay = 0;
    
    // Handle exact same times edge case
    if (dropoffMinutes > pickupMinutes) {
      extraDay = 1;
    } else if (dropoffMinutes === pickupMinutes) {
      // If minutes are the same, check seconds for absolute precision
      const pickupSeconds = pickupDate.getSeconds();
      const dropoffSeconds = dropoffDate.getSeconds();
      if (dropoffSeconds > pickupSeconds) {
        extraDay = 1;
      }
    }
    
    return fullDays + extraDay;
  };

  // --- useEffect for Final Price Calculation (MODIFIED for Custom Price) ---
  // Calculates the final display price including coupon and VAT
  useEffect(() => {
    if (formData.pickupDate && formData.dropoffDate && selectedCar) {
      // Get the base total price (already considers custom price and duration discounts)
      const baseTotal = calculateBaseTotalPrice();

      // Calculate net total before VAT
      const netTotal = baseTotal / 1.24;

      // Apply coupon discount if valid
      // Ensure discount doesn't exceed the net total
      const applicableDiscount = couponStatus.isValid ? Math.min(couponStatus.discount, netTotal) : 0;
      const netAfterDiscount = netTotal - applicableDiscount;

      // Apply VAT to get the final total
      const finalTotal = netAfterDiscount * 1.24;

      setTotalPrice(finalTotal >= 0 ? finalTotal : 0); // Ensure price doesn't go below zero
    } else {
      setTotalPrice(0); // Reset price if prerequisites are not met
    }
  }, [
    formData.pickupDate,
    formData.dropoffDate,
    selectedCar,
    calculateBaseTotalPrice,
    couponStatus.isValid,
    couponStatus.discount,
  ]);


  // --- Validate Coupon ---
  const validateCoupon = async (code) => {
    if (!code) {
      setCouponStatus({ isValid: false, discount: 0, message: "" });
      return;
    }
     if (!formData.pickupDate || !formData.dropoffDate || !selectedCar) {
        setCouponStatus({ isValid: false, discount: 0, message: "✕ Select car & dates first" });
        return;
     }

    try {
      // Validate coupon against the net amount *before* VAT and *before* this coupon's discount
      const baseTotal = calculateBaseTotalPrice();
      const netTotalBeforeVat = baseTotal / 1.24;

      if (netTotalBeforeVat <= 0) {
         setCouponStatus({ isValid: false, discount: 0, message: "✕ Cannot apply coupon to zero/negative price" });
         return;
      }

      const response = await coupons.validate(code, netTotalBeforeVat); // Pass net amount
      setCouponStatus({
        isValid: true,
        discount: response.data.discount, // Store the discount amount provided by API
        message: `✓ ${response.data.message || 'Coupon applied!'}`, // Use API message or default
      });
    } catch (error) {
       const errorMessage = error.response?.data?.message || "✕ Invalid or expired coupon code";
      setCouponStatus({
        isValid: false,
        discount: 0,
        message: errorMessage,
      });
    }
  };


  // --- Validate Form (MODIFIED for Payment Method) ---
  const validateForm = () => {
    const newErrors = {};

    // Car Selection
    if (!selectedCar) newErrors.car = "Please select a car";

    // Dates & Times
    if (!formData.pickupDate) newErrors.pickupDate = "Pick-up date & time required";
    else if (!dateTimeComplete.pickup) newErrors.pickupDate = "Pick-up time required"; // Check if time is selected

    if (!formData.dropoffDate) newErrors.dropoffDate = "Drop-off date & time required";
     else if (!dateTimeComplete.dropoff) newErrors.dropoffDate = "Drop-off time required"; // Check if time is selected

    // Date Order Validation (already handled in validateDates, but double-check here)
     if (formData.pickupDate && formData.dropoffDate && formData.pickupDate >= formData.dropoffDate) {
        newErrors.dropoffDate = "Drop-off must be strictly after pick-up";
     }

    // Advanced Payment Validation (NEW)
    if (formData.advancePayment) {
      const advancePayment = parseFloat(formData.advancePayment);
      if (isNaN(advancePayment) || advancePayment < 0) {
        newErrors.advancePayment = "Advanced payment must be a positive number";
      } else if (advancePayment > totalPrice) {
        newErrors.advancePayment = "Advanced payment cannot exceed total price";
      }
    }

    // Customer Info
    if (!formData.firstName.trim()) newErrors.firstName = "First name is required";
    if (!formData.lastName.trim()) newErrors.lastName = "Last name is required";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Invalid email address format";
    }
    if (!formData.phone.trim()) newErrors.phone = "Phone number is required";
    // Basic phone format check (optional, adjust regex as needed)
    else if (!/^\+?[0-9\s\-()]{7,}$/.test(formData.phone)) {
       newErrors.phone = "Invalid phone number format";
    }
     if (!formData.age) newErrors.age = "Age selection is required"; // Ensure age is selected
    // Locations
    if (!isPartnerMode) {
      if (!formData.pickupLocation) {
        newErrors.pickupLocation = "Pick-up location is required";
      } else if (formData.pickupLocation === "other" && !formData.customPickupLocation.trim()) {
        newErrors.pickupLocation = "Please specify the custom pick-up location";
      }

      if (!sameLocation) {
        if (!formData.dropoffLocation) {
          newErrors.dropoffLocation = "Drop-off location is required";
        } else if (formData.dropoffLocation === "other" && !formData.customDropoffLocation.trim()) {
          newErrors.dropoffLocation = "Please specify the custom drop-off location";
        }
      }
    } else {
      // Partner mode validation - ensure custom locations are provided
      if (!formData.customPickupLocation.trim()) {
        newErrors.pickupLocation = "Pick-up location is required for partner bookings";
      }
      if (!sameLocation && !formData.customDropoffLocation.trim()) {
        newErrors.dropoffLocation = "Drop-off location is required for partner bookings";
      }
    }

    // Invoice Validation (NEW)
    if (wantsInvoice) {
      if (!invoiceData.companyName.trim()) newErrors.companyName = "Company name is required for invoice";
      if (!invoiceData.vatNumber.trim()) newErrors.vatNumber = "VAT number is required for invoice";
      if (!invoiceData.address.trim()) newErrors.address = "Address is required for invoice";
      if (!invoiceData.city.trim()) newErrors.city = "City is required for invoice";
      if (!invoiceData.postalCode.trim()) newErrors.postalCode = "Postal code is required for invoice";
    }    // Payment method validation
    if (!formData.paymentMethod) {
      newErrors.paymentMethod = "Please select a payment method";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };


  // --- Format Date Range for Display ---
  const formatDateRange = (date) => {
    return date.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit" });
  };

  // --- Render Day Contents in DatePicker ---
  const renderDayContents = (day, date) => {
    if (!selectedCar) return day; // Return day number if no car selected

    const dayDate = new Date(date);
    dayDate.setHours(0, 0, 0, 0); // Normalize date for comparison

    // --- Custom Price Check ---
    const customPriceStr = formData.customPricePerDay;
    const customPrice = customPriceStr ? parseFloat(customPriceStr) : null;
    const isCustomPriceValid = customPrice !== null && !isNaN(customPrice) && customPrice > 0;
    // ---

    let dayPrice = null;
    let priceType = 'base'; // 'base', 'dynamic', 'custom'

    if (isCustomPriceValid) {
        dayPrice = customPrice;
        priceType = 'custom';
    } else if (availabilityData?.dynamicPrices) {
      const dynamicPriceData = availabilityData.dynamicPrices.find(
        (p) => new Date(p.date).toDateString() === dayDate.toDateString()
      );
      if (dynamicPriceData?.dynamicPrice) {
          dayPrice = dynamicPriceData.dynamicPrice;
          priceType = 'dynamic';
      }
    }

    // Fallback to base price if no custom or dynamic price found
    if (dayPrice === null && selectedCar.basePrice) {
      dayPrice = selectedCar.basePrice;
      priceType = 'base';
    }


    return (
      <div className="relative h-full flex items-center justify-center"> {/* Ensure div takes full height */}
        <span>{dayDate.getDate()}</span>
        {dayPrice !== null && (
          <div
            className={`absolute top-5 left-0 right-0 text-[9px] font-semibold text-center ${
              priceType === 'custom' ? 'text-yellow-600' :
              priceType === 'dynamic' ? 'text-blue-600' :
              'text-green-600' // Base price color
            }`}
            title={`€${dayPrice.toFixed(2)} (${priceType})`} // Tooltip for clarity
          >
            €{dayPrice.toFixed(0)} {/* Show rounded price for space */}
          </div>
        )}
      </div>
    );
  };


  // --- Invoice Generation Colors ---
  const colors = {
    primary: "#D81919", // Example primary color
    secondary: "#990000", // Example secondary color
    accent: "#FFEDED", // Example accent color
    dark: "#333333",
    light: "#FFFFFF",
    gray: "#F8F8F8",
  };

  // --- Generate Invoice PDF (Modified for Additional Options) ---
  const generateInvoice = async (rental) => {
    const invoiceDiv = document.createElement("div");
    invoiceDiv.style.padding = "10px";
    invoiceDiv.style.position = "absolute";
    invoiceDiv.style.left = "-9999px";
    invoiceDiv.style.background = "white";
    invoiceDiv.style.width = "900px";

    const header = `
    <div style="display: flex; justify-content: space-between; margin-bottom: 40px; position: relative;">
      <div style="width: 66%; position: relative; overflow: hidden; height: 120px;">
        <div style="position: absolute; top: -20px; left: -200px; width: calc(100% + 220px); height: calc(100% + 40px); transform: skew(-15deg); z-index: 0; box-shadow: 0 3px 10px rgba(0,0,0,0.2);"></div>
        <img src="${logo}" alt="Logo" style="width: 85%; height: 100%; object-fit: contain; position: relative; z-index: 1; padding: 20px 20px 20px 40px;" />
      </div>
      <div style="width: 32%; text-align: right; padding: 20px; background: ${colors.gray}; border-right: 5px solid ${colors.primary}; box-shadow: 0 3px 8px rgba(0,0,0,0.1);">
        <h2 style="margin-bottom: 15px; color: ${colors.primary}; font-size: 22px; font-weight: bold;">Contact Information</h2>
        <p style="margin: 5px 0; color: ${colors.dark};">Epar. Odos Mykonos 846 00</p>
        <p style="margin: 5px 0; color: ${colors.dark};">nleont@gmail.com</p>
        <p style="margin: 5px 0; color: ${colors.dark}; font-weight: bold;">+306941419012</p>
        <p style="margin: 5px 0; color: ${colors.primary};">${window.location.origin}</p>
      </div>
    </div>
    <div style="text-align: center; margin-bottom: 30px; padding: 10px 0; border-bottom: 2px solid ${colors.primary}; border-top: 2px solid ${colors.primary};">
      <h1 style="margin: 0; color: ${colors.primary}; font-size: 28px; text-transform: uppercase; letter-spacing: 2px;">PRE-INVOICE</h1>
      <p style="margin: 5px 0; color: ${colors.dark};">Pre-Invoice #: INV-${new Date().getFullYear()}-${Math.floor(Math.random() * 1000000)}</p>
      <p style="margin: 5px 0; color: ${colors.dark};">Pre-Invoice Date: ${new Date().toLocaleDateString("en-GB")}</p>
    </div>
  `;

  console.log("Generating invoice for rental:", rental);

    const infoSection = `
    <div style="display: flex; justify-content: space-between; margin-bottom: 40px; gap: 40px;">
      <div style="flex: 1; background: ${colors.accent}; padding: 25px; border-radius: 8px; border-left: 6px solid ${colors.primary}; box-shadow: 0 3px 10px rgba(0,0,0,0.1);">
      <h3 style="margin-bottom: 15px; color: ${colors.primary}; text-transform: uppercase; font-weight: bold; border-bottom: 2px solid ${colors.primary}; padding-bottom: 8px;">CLIENT DETAILS</h3>
      <p style="margin: 10px 0; font-weight: bold; font-size: 16px;">${rental.customer.firstName} ${rental.customer.lastName}</p>
      <p style="margin: 8px 0;"><span style="color: ${colors.secondary}; font-weight: bold;">Phone:</span> ${rental.customer.phoneNumber}</p>
      <p style="margin: 8px 0;"><span style="color: ${colors.secondary}; font-weight: bold;">Email:</span> ${rental.customer.email}</p>
      <p style="margin: 8px 0;"><span style="color: ${colors.secondary}; font-weight: bold;">Age:</span> ${rental.customer.age}</p>
      </div>
      <div style="flex: 1; background: ${colors.accent}; padding: 25px; border-radius: 8px; border-left: 6px solid ${colors.primary}; box-shadow: 0 3px 10px rgba(0,0,0,0.1);">
      <h3 style="margin-bottom: 15px; color: ${colors.primary}; text-transform: uppercase; font-weight: bold; border-bottom: 2px solid ${colors.primary}; padding-bottom: 8px;">VEHICLE INFORMATION</h3>
      <p style="margin: 10px 0; font-weight: bold; font-size: 16px;"><span style="color: ${colors.secondary}; font-weight: bold;">Vehicle Name:</span> ${rental.car ? rental.car.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) : rental.carName}</p>
      <p style="margin: 8px 0;"><span style="color: ${colors.secondary}; font-weight: bold;">Rental Period:</span> ${new Date(
      rental.pickupDateTime
    ).toLocaleDateString("en-GB")} ${new Date(rental.pickupDateTime).toLocaleTimeString("en-GB", {hour: '2-digit', minute:'2-digit'})} - ${new Date(
      rental.returnDateTime
    ).toLocaleDateString("en-GB")} ${new Date(rental.returnDateTime).toLocaleTimeString("en-GB", {hour: '2-digit', minute:'2-digit'})}</p>
      <p style="margin: 8px 0;"><span style="color: ${colors.secondary}; font-weight: bold;">Pick-up:</span> ${rental.pickupLocation}</p>
      <p style="margin: 8px 0;"><span style="color: ${colors.secondary}; font-weight: bold;">Return:</span> ${rental.returnLocation}</p>
      </div>
    </div>
    `;

    const priceRows = rental.priceBreakdown
      .map(
        (period, index) => `
    <tr style="background-color: ${
      index % 2 === 0 ? colors.light : colors.accent
    };">
      <td style="padding: 14px; border-bottom: 1px solid #ddd; font-weight: bold;">
        Rental (${new Date(period.startDate).toLocaleDateString(
          "en-GB"
        )} - ${new Date(period.endDate).toLocaleDateString("en-GB")})
      </td>
      <td style="padding: 14px; border-bottom: 1px solid #ddd; text-align: center;">€${
        period.pricePerDay
      }</td>
      <td style="padding: 14px; border-bottom: 1px solid #ddd; text-align: center;">${
        period.numberOfDays
      }</td>
      <td style="padding: 14px; border-bottom: 1px solid #ddd; text-align: right; font-weight: bold;">€${
        period.totalForPeriod
      }</td>
    </tr>
  `
      )
      .join("");

    // Generate additional options rows matching CarDetails format
    const additionalOptionsRows = [];
    if (rental.additionalOptions && Array.isArray(rental.additionalOptions) && rental.totalRentalDays !== undefined) {
      const totalDaysForInvoice = rental.totalRentalDays;
      rental.additionalOptions.forEach(option => {
        additionalOptionsRows.push(
          `<tr style="background-color: ${colors.accent};">
             <td style="padding: 14px; border-bottom: 1px solid #ddd;">${option.name} (Additional Option)</td>
             <td style="padding: 14px; border-bottom: 1px solid #ddd; text-align: center;">€${option.price.toFixed(2)}</td>
             <td style="padding: 14px; border-bottom: 1px solid #ddd; text-align: center;">${totalDaysForInvoice}</td>
             <td style="padding: 14px; border-bottom: 1px solid #ddd; text-align: right; font-weight: bold;">€${(option.price * totalDaysForInvoice).toFixed(2)}</td>
           </tr>`
        );
      });
    }

    const priceTable = `
    <table style="width: 100%; border-collapse: collapse; margin-bottom: 30px; border: 2px solid ${
      colors.primary
    }; border-radius: 8px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.15);">
      <thead>
        <tr style="background: ${colors.primary}; color: white;">
          <th style="padding: 15px; text-align: left; font-size: 15px;">Description</th>
          <th style="padding: 15px; text-align: center; font-size: 15px;">Rate</th>
          <th style="padding: 15px; text-align: center; font-size: 15px;">Quantity</th>
          <th style="padding: 15px; text-align: right; font-size: 15px;">Amount</th>
        </tr>
      </thead>
      <tbody>
        ${priceRows}
        ${additionalOptionsRows.join("")}
      </tbody>
    </table>
  `;

    const additionalNotesSection = rental.additionalNotes
      ? `
      <div style="margin-bottom: 20px; background: #f8f8f8; padding: 15px; border-left: 4px solid #1e3a8a;">
        <h4 style="margin-bottom: 10px; color: #1e3a8a; text-transform: uppercase; font-weight: bold;">Additional Notes</h4>
        <p style="margin: 0; font-style: italic;">${rental.additionalNotes}</p>
      </div>
    `
      : "";

    const totalsSection = `
    <div style="display: flex; justify-content: flex-end;">
      <div style="width: 350px;">
        <div style="border: 2px solid ${
          colors.primary
        }; border-radius: 8px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.15);">
          <div style="padding: 14px; border-bottom: 1px solid #ddd; background: ${
            colors.accent
          };">
            <div style="display: flex; justify-content: space-between;">
              <span style="font-weight: bold;">Subtotal:</span>
              <span>€${(rental.totalPrice / 1.24).toFixed(2)}</span>
            </div>
          </div>
          ${
            rental.discountAmount
              ? `
          <div style="padding: 14px; border-bottom: 1px solid #ddd; background: ${
            colors.accent
          }; color: ${colors.primary};">
            <div style="display: flex; justify-content: space-between;">
              <span style="font-weight: bold;">Discount:</span>
              <span>-€${rental.discountAmount.toFixed(2)}</span>
            </div>
          </div>
          `
              : ""
          }
          <div style="padding: 14px; border-bottom: 1px solid #ddd; background: ${
            colors.accent
          };">
            <div style="display: flex; justify-content: space-between;">
              <span style="font-weight: bold;">VAT (24%):</span>
              <span>€${(rental.totalPrice - rental.totalPrice / 1.24).toFixed(
                2
              )}</span>
            </div>
          </div>
          <div style="padding: 16px; background: ${
            colors.primary
          }; color: white;">
            <div style="display: flex; justify-content: space-between; font-weight: bold; font-size: 18px;">
              <span>TOTAL:</span>
              <span>€${rental.totalPrice.toFixed(2)} (NOT PAID)</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;

    const footer = `
    <div style="margin-top: 50px;">
      <div style="margin-bottom: 30px; padding: 20px; background: ${colors.accent}; border-radius: 8px; border-left: 6px solid ${colors.primary}; box-shadow: 0 3px 10px rgba(0,0,0,0.1);">
        <p style="margin: 0; font-style: italic; color: ${colors.dark};">Thank you for choosing <span style="font-weight: bold; color: ${colors.primary};">Luxury Car Mykonos Rental</span>. For assistance, contact us at <span style="font-weight: bold;">+306941419012</span> or <span style="font-weight: bold;">nleont@gmail.com</span></p>
      </div>
      <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 30px;">
        <div style="width: 30%;">
          <div style="background: ${colors.primary}; height: 4px; margin-bottom: 5px;"></div>
          <div style="background: ${colors.primary}; height: 2px;"></div>
        </div>
        <div style="width: 200px; text-align: center;">
          <div style="border-bottom: 2px solid ${colors.primary}; margin-bottom: 8px; padding-bottom: 15px;">
            <img src="data:image/png;base64,..." alt="Signature" style="max-width: 150px;" />
          </div>
          <p style="margin: 0; font-weight: bold; color: ${colors.primary};">Nikos Leontitsis</p>
          <p style="margin: 0; color: ${colors.dark};">Managing Director</p>
        </div>
        <div style="width: 30%;">
          <div style="background: ${colors.primary}; height: 4px; margin-bottom: 5px;"></div>
          <div style="background: ${colors.primary}; height: 2px;"></div>
        </div>
      </div>
    </div>
    <div style="margin-top: 40px; text-align: center; padding-top: 20px; border-top: 2px dashed ${colors.accent};">
    </div>
  `;

    invoiceDiv.innerHTML =
      header +
      infoSection +
      priceTable +
      additionalNotesSection +
      totalsSection +
      footer;
    document.body.appendChild(invoiceDiv);

    try {
      const scale = 2;
      const canvas = await html2canvas(invoiceDiv, {
        scale: scale,
        logging: false,
        useCORS: true,
        allowTaint: true,
      });

      const imgData = canvas.toDataURL("image/jpeg", 1.0);
      const pdf = new jsPDF("p", "pt", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width / scale;
      const imgHeight = canvas.height / scale;
      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      const imgX = (pdfWidth - imgWidth * ratio) / 2;
      const imgY = 20;

      pdf.addImage(
        imgData,
        "JPEG",
        imgX,
        imgY,
        imgWidth * ratio,
        imgHeight * ratio
      );

      const pageCount = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        pdf.setPage(i);
        pdf.setFontSize(10);
        pdf.setTextColor(150);
      }

      const pdfData = pdf.output("datauristring");
      return pdfData.split(",")[1];
    } finally {      document.body.removeChild(invoiceDiv);
    }
  };

  const getLocationNameFromId = (locationId) => {
    console.log('getLocationNameFromId called with:', locationId);
    console.log('Available locationOptions:', locationOptions);
    
    // Handle empty or null values
    if (!locationId) {
      console.log('No locationId provided, returning Unknown Location');
      return "Unknown Location";
    }
    
    // Handle "other" location type
    if (locationId === "other") {
      console.log('LocationId is "other", returning Other Location');
      return "Other Location";
    }
    
    // Handle custom location inputs
    if (locationId === formData.customPickupLocation || locationId === formData.customDropoffLocation) {
      console.log('LocationId matches custom location:', locationId);
      return locationId; // Return the custom location text
    }
    
    // Try to find the location option with the matching ID
    const locationOption = locationOptions.find(option => option.value === locationId);
    console.log('Found location option:', locationOption);
    
    if (locationOption) {
      console.log('Returning location label:', locationOption.label);
      return locationOption.label;
    } else {
      console.log('No matching location found, returning original ID:', locationId);
      return locationId;
    }
  };

  // --- Handle Form Submission (ENHANCED for Partner Support) ---
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      const firstError = document.querySelector('[data-error="true"]');
      if (firstError) {
        firstError.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      return;
    }

    setLoading(true);
    try {      // Get effective location names
      console.log('Raw location values from formData:', {
        pickupLocation: formData.pickupLocation,
        dropoffLocation: formData.dropoffLocation,
        customPickupLocation: formData.customPickupLocation,
        customDropoffLocation: formData.customDropoffLocation
      });
      
      let effectivePickupLocation;
      let effectiveDropoffLocation;

      if (isPartnerMode) {
        // For partner mode, always use custom location values (partner name)
        effectivePickupLocation = formData.customPickupLocation || partner?.firstName || "Partner Location";
        effectiveDropoffLocation = sameLocation 
          ? effectivePickupLocation 
          : (formData.customDropoffLocation || partner?.firstName || "Partner Location");
      } else {
        // For normal mode, use the existing logic
        effectivePickupLocation = formData.pickupLocation === "other"
          ? formData.customPickupLocation
          : getLocationNameFromId(formData.pickupLocation);

        effectiveDropoffLocation = formData.dropoffLocation === "other"
          ? formData.customDropoffLocation
          : getLocationNameFromId(formData.dropoffLocation);
      }

      console.log('Effective location names for submission:', {
        effectivePickupLocation,
        effectiveDropoffLocation
      });

      const priceForCouponValidation = calculateBaseTotalPrice();
      const netPriceForCouponValidation = priceForCouponValidation / 1.24;

      let serverValidatedDiscountAmount = 0;
      if (formData.couponCode) {
        try {
          const couponResponse = await coupons.validate(
            formData.couponCode,
            netPriceForCouponValidation
          );
          serverValidatedDiscountAmount = couponResponse.data.discount;
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Invalid Coupon",
            text: "The coupon code you entered is not valid or does not apply.",
          });
          setLoading(false);
          return;
        }
      }

      const netPriceBeforeCoupon = priceForCouponValidation / 1.24;
      const actualDiscountToApply = Math.min(serverValidatedDiscountAmount, netPriceBeforeCoupon);
      const netPriceAfterDiscount = netPriceBeforeCoupon - actualDiscountToApply;
      const finalTotalForSubmission = netPriceAfterDiscount * 1.24;

      const totalRentalDays = calculateDurationIn24HourDays(formData.pickupDate, formData.dropoffDate);
      
      // Process additional options to match CarDetails format
      const processedAdditionalOptions = [];
      if (additionalOptionsData.length > 0 && formData.additionalOptions) {
        additionalOptionsData.forEach(option => {
          if (formData.additionalOptions[option._id]) {
            processedAdditionalOptions.push({
              _id: option._id,
              name: option.name,
              price: option.price, // This is price per day
            });
          }
        });
      }

      const priceBreakdown = calculatePriceBreakdown()?.map((period) => ({
        startDate: period.startDate.toISOString(),
        endDate: period.endDate.toISOString(),
        pricePerDay: period.price,
        numberOfDays: period.days,
        totalForPeriod: period.price * period.days,
      }));          console.log(selectedCar, "Selected Car Details for Rental Submission");
      console.log('Final location values being sent to server:', {
        pickupLocation: effectivePickupLocation,
        returnLocation: effectiveDropoffLocation
      });
      console.log('Payment method being sent:', formData.paymentMethod);
      console.log('Complete form data:', formData);

      // Check if a valid custom price was set (for partner mode)
      const customPriceStr = formData.customPricePerDay;
      const customPrice = customPriceStr !== "" && customPriceStr !== null && customPriceStr !== undefined
        ? parseFloat(customPriceStr)
        : null;
      const isCustomPriceValid = customPrice !== null && !isNaN(customPrice) && customPrice > 0;

      // Check for advance payment
      const advancePaymentStr = formData.advancePayment;
      const advancePayment = advancePaymentStr ? parseFloat(advancePaymentStr) : 0;
      const hasAdvancePayment = advancePayment > 0 && !isNaN(advancePayment);

      const rentalData = {
        car: selectedCar?.stringId,
        carName: isPartnerMode ? `${selectedCar.make} ${selectedCar.model}` : selectedCar?.name,
        customer: {
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          phoneNumber: formData.phone,
          age: formData.age,
        },
        pickupLocation: effectivePickupLocation,
        returnLocation: effectiveDropoffLocation,
        pickupDateTime: moment.tz({
          year: formData.pickupDate.getFullYear(),
          month: formData.pickupDate.getMonth(),
          date: formData.pickupDate.getDate(),
          hour: formData.pickupDate.getHours(),
          minute: formData.pickupDate.getMinutes()
        }, 'Europe/Athens').utc().toISOString(),
        returnDateTime: moment.tz({
          year: formData.dropoffDate.getFullYear(),
          month: formData.dropoffDate.getMonth(),
          date: formData.dropoffDate.getDate(),
          hour: formData.dropoffDate.getHours(),
          minute: formData.dropoffDate.getMinutes()
        }, 'Europe/Athens').utc().toISOString(),
        additionalOptions: processedAdditionalOptions,
        totalRentalDays: totalRentalDays,
        couponCode: formData.couponCode || undefined,
        basePrice: selectedCar?.basePrice,
        totalPrice: finalTotalForSubmission,
        discountAmount: actualDiscountToApply,        priceBreakdown,
        additionalNotes: formData.notes,
        advancePayment: hasAdvancePayment ? advancePayment : undefined,
        paymentMethod: formData.paymentMethod,
        // Add invoice data (only for non-partner mode)
        invoiceType: !isPartnerMode && wantsInvoice ? "invoice" : "receipt",
        invoiceData: !isPartnerMode && wantsInvoice ? invoiceData : undefined,
      };

      // Partner-specific additions
      if (isPartnerMode && partner) {
        // Calculate commission amount based on partner's rate and net price *after* discount
        const commissionRate = partner?.commissionRate || 0;
        const commissionAmount = (netPriceAfterDiscount * commissionRate) / 100;

        rentalData.professionalPartnerId = partner._id;
        rentalData.commissionAmount = commissionAmount;
        rentalData.status = "pending";
        
        // Include custom price if valid and user is partner/admin
        if (isCustomPriceValid && (partner?.isProfessionalPartner || partner?.isAdmin)) {
          rentalData.customPricePerDay = customPrice;
        }
      }      // Generate PDF data first
      const pdfData = await generateInvoice(rentalData);
      rentalData.invoicePdf = pdfData;

      console.log('Final rental data being sent to server:', rentalData);

      const response = await rentals.create(rentalData);

      Swal.fire({
        icon: "success",
        title: "Booking Created!",
        text: "The booking has been successfully created.",
        timer: 2000,
        showConfirmButton: false,
      });

      onSuccess(response.data);
      onClose();
    } catch (error) {
      console.error("Error creating rental:", error);
      // Provide more specific error feedback if possible
      const errorMessage = error.response?.data?.message || "Failed to create rental. Please try again.";
      setErrors({ submit: errorMessage });
    } finally {
      setLoading(false);
    }
  };


  // --- Custom Input Component for DatePicker ---
  const CustomInputComponent = React.forwardRef(({ value, onClick, placeholder, isError, icon: Icon }, ref) => (
    <button
      type="button"
      className={`w-full flex items-center px-4 py-2 border ${
        isError ? "border-red-500 bg-red-50" : "border-gray-300"
      } rounded-md transition-all hover:border-blue-500 text-left ${value ? 'text-gray-900' : 'text-gray-400'}`} // Style placeholder text
      onClick={onClick}
      ref={ref}
    >
      {Icon && <Icon className="text-gray-500 mr-2 flex-shrink-0" />}
      <span className="flex-grow">{value || placeholder}</span>
    </button>
  ));
  CustomInputComponent.displayName = 'CustomInputComponent'; // Add display name


const CustomSelect = ({
    value,
    onChange,
    onOtherLocationChange,
    options,
    placeholder,
    showOtherInput = false,
    initialCustomValue = "",
    disabled = false,
  }) => {
    const [showOtherInputField, setShowOtherInputField] = useState(
      value === "other"
    );
    // Add local state to manage input value
    const [localInputValue, setLocalInputValue] = useState(initialCustomValue || '');

    // Update local state when prop changes
    useEffect(() => {
      setLocalInputValue(initialCustomValue || '');
    }, [initialCustomValue]);

    useEffect(() => {
      setShowOtherInputField(value === "other" && showOtherInput);
    }, [value, showOtherInput]);

    // Handle local input changes without immediate parent updates
    const handleLocalInputChange = (e) => {
      setLocalInputValue(e.target.value);
    };

    // Update parent component only when focus is lost or Enter is pressed
    const handleInputBlur = () => {
      onOtherLocationChange(localInputValue);
    };

    const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        onOtherLocationChange(localInputValue);
      }
    };

    return (
      <div>
        <div className="relative">
          <select
            value={value}
            onChange={(e) => {
              onChange(e);
              setShowOtherInputField(
                e.target.value === "other" && showOtherInput
              );
            }}
            disabled={disabled}
            className={`w-full h-10 pl-3 pr-10 border border-gray-300 rounded bg-white hover:border-blue-500 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none ${
              disabled ? "bg-gray-100 cursor-not-allowed opacity-70" : "" // Style for disabled
            }`}
          >
            <option value="">{placeholder}</option>
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
            <svg
              className="w-4 h-4 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                d="M19 9l-7 7-7-7"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
            </svg>
          </div>
        </div>
        {showOtherInputField && (
          <input
            type="text"
            placeholder="Enter location details"
            value={localInputValue}
            onChange={handleLocalInputChange}
            onBlur={handleInputBlur}
            onKeyDown={handleKeyDown}
            disabled={disabled}
            className={`w-full h-10 px-3 mt-2 border border-gray-200 rounded bg-white hover:border-blue-500 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 ${
              disabled ? "bg-gray-100 cursor-not-allowed opacity-70" : "" // Style for disabled
            }`}
          />
        )}
      </div>
    );
  };

  // --- Custom Checkbox Component ---
   const CustomCheckbox = ({ id, checked, onChange, label, disabled = false }) => (
        <label htmlFor={id} className={`flex items-center group p-2 rounded-md transition-colors ${disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer hover:bg-gray-50'}`}>
        <div className="relative w-5 h-5 mr-3">
            <input
            id={id}
            type="checkbox"
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            className="opacity-0 absolute h-5 w-5 cursor-pointer"
            />
            <div
            className={`border-2 rounded-sm h-5 w-5 flex flex-shrink-0 justify-center items-center ${
                checked ? "bg-blue-500 border-blue-500" : "border-gray-300"
            } ${disabled ? 'bg-gray-200 border-gray-300' : 'focus-within:border-blue-500'}`}
            aria-hidden="true" // Hide decorative element from screen readers
            >
            {checked && (
                <svg
                className={`fill-current w-3 h-3 pointer-events-none ${disabled ? 'text-gray-400' : 'text-white'}`}
                viewBox="0 0 20 20"
                >
                <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
                </svg>
            )}
            </div>
        </div>
        <span className={`select-none ${disabled ? 'text-gray-500' : 'text-gray-700'}`}>{label}</span>
        </label>
    );


  // --- Filter Cars based on Search and Category ---
  const filteredCars = availableCars.filter((car) => {
    const searchLower = searchQuery.toLowerCase();
    const matchesSearch =
      !searchQuery ||
      `${car.make} ${car.model}`.toLowerCase().includes(searchLower) ||
      car.category?.toLowerCase().includes(searchLower); // Include category in search
    const matchesCategory = !selectedCategory || car.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  // --- Render Null if Modal is Closed ---
  if (!isOpen) return null;

  // --- Modal JSX ---
  return (
    <div className="fixed inset-0 z-50 overflow-hidden bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center p-4"> {/* Added padding */}
      <motion.div
        initial={{ opacity: 0, y: -20 }} // Slide down animation
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 20 }} // Slide up animation
        transition={{ duration: 0.3, ease: "easeInOut" }}
        className="bg-white rounded-xl shadow-2xl w-full max-w-6xl relative max-h-[95vh] overflow-hidden flex flex-col" // Flex column layout
      >
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-900 to-blue-700 px-6 py-4 flex justify-between items-center flex-shrink-0"> {/* Shrink header */}
          <div className="flex items-center space-x-3">
            <FaCarSide className="text-white text-2xl" />
          <h2 className="text-xl font-bold text-white">
            {isPartnerMode && partner
              ? `Create New Rental for: ${partner.firstName}`
              : "Create New Rental"}
          </h2>          </div>
          <button
            onClick={onClose}
            className="p-1.5 hover:bg-blue-700 rounded-full transition-colors text-white focus:outline-none focus:ring-2 focus:ring-white" // Improved focus
            aria-label="Close modal" // Accessibility
          >
            <IoClose size={24} />
          </button>
        </div>

        {/* Content Area */}
        {initialLoading ? (
          <div className="p-8 flex flex-col items-center justify-center flex-grow"> {/* Grow to fill space */}
            <LoadingSpinner size="lg" />
            <p className="mt-4 text-gray-500">Loading available cars...</p>
          </div>
        ) : (
          <div className="overflow-y-auto flex-grow"> {/* Scrollable content */}
            <div className="p-6">
                           <form onSubmit={handleSubmit} noValidate>
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

                  {/* --- Car Selection Column --- */}
                  <div className="lg:col-span-1 flex flex-col">
                    <h3 className="text-lg font-semibold mb-4 text-gray-800">1. Select a Car</h3>
                    {/* Search and Filter */}
                    <div className="sticky top-0 bg-white z-10 p-4 mb-4 border border-gray-200 rounded-lg shadow-sm flex-shrink-0">
                      <div className="space-y-3">
                         <input
                            type="search" // Use type search
                            placeholder="Search make, model, category..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            aria-label="Search available cars"
                         />
                         <select
                            value={selectedCategory}
                            onChange={(e) => setSelectedCategory(e.target.value)}
                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            aria-label="Filter by car category"
                         >
                            <option value="">All Categories</option>
                            {Array.from(new Set(availableCars.map((car) => car.category)))
                                .sort() // Sort categories
                                .map((category) => (
                                <option key={category} value={category}>
                                    {category}
                                </option>
                                ))}
                         </select>
                      </div>
                       {errors.car && <p className="mt-2 text-sm text-red-600">{errors.car}</p>}
                    </div>
                    {/* Car List */}
                    <div className="flex-grow overflow-y-auto border border-gray-200 rounded-lg min-h-[300px] max-h-[1200px]"> {/* Ensure min height */}
                      <div className="divide-y divide-gray-200">
                        {filteredCars.length > 0 ? (
                          filteredCars.map((car) => (
                            <div
                              key={car._id}
                              className={`p-4 cursor-pointer hover:bg-gray-100 transition-colors duration-150 ${
                                selectedCar?._id === car._id ? "bg-blue-50 border-l-4 border-blue-600" : "border-l-4 border-transparent"
                              }`}
                              onClick={() => handleCarSelect(car)}
                              role="button" tabIndex={0}
                              onKeyPress={(e) => e.key === 'Enter' && handleCarSelect(car)}
                              aria-pressed={selectedCar?._id === car._id} // Accessibility state
                            >
                              <div className="flex items-center space-x-4">
                                <div className="flex-shrink-0 h-16 w-20 bg-gray-100 rounded-md flex items-center justify-center overflow-hidden border"> {/* Slightly larger image */}
                                  <img
                                    src={getImage(car.images?.[0]) || "https://placehold.co/80x64/e2e8f0/94a3b8?text=No+Image"} // Placeholder
                                    alt={`${car.make} ${car.model}`}
                                    className="h-full w-full object-contain"
                                    loading="lazy"
                                    onError={(e) => { e.target.src = "https://placehold.co/80x64/e2e8f0/94a3b8?text=Error"; }}
                                  />
                                </div>
                                <div className="flex-1 min-w-0">
                                  <p className="text-sm font-semibold text-gray-900 truncate">{car.make} {car.model}</p>
                                  <p className="text-xs text-gray-500">{car.year} • {car.category}</p>
                                  <p className="text-sm font-bold text-blue-800 mt-1">€{car.basePrice}/day</p>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="p-6 text-center text-gray-500">No cars found.</div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* --- Rental Details Column --- */}
                  <div className="lg:col-span-2 space-y-6">
                    <h3 className="text-lg font-semibold text-gray-800">
                      2. Rental Details {selectedCar ? `for ${selectedCar.make} ${selectedCar.model}` : ''}
                    </h3>

                    {/* Show message if no car selected */}
                    {!selectedCar ? (
                       <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 rounded-md" role="alert">
                         <p className="font-medium">Please select a car from the list to continue.</p>
                       </div>
                     ) : (
                      <>
                        {/* --- Date Selection --- */}
                        <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
                          <h4 className="font-medium text-gray-700 mb-3 text-base">Rental Period</h4>
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {/* Pickup Date */}
                            <div>
                              <label htmlFor="pickupDate" className="block text-sm font-medium text-gray-600 mb-1">
                                Pick-up Date & Time *
                                <span className="ml-2 text-xs text-blue-600 bg-blue-50 px-2 py-1 rounded">
                                  Athens Time (GMT+2/+3)
                                </span>
                              </label>
                              <p className="text-xs text-gray-500 mb-2">
                                Times are shown and stored in Athens timezone, regardless of your location
                              </p>
                              <DatePicker
                                id="pickupDate"
                                selected={formData.pickupDate}
                                onChange={(date) => handleDateChange(date, "pickupDate")}
                                onMonthChange={handleMonthChange}
                                customInput={<CustomInputComponent placeholder="Select Pick-up" isError={!!errors.pickupDate} icon={FaCalendarAlt} />}
                                dateFormat="dd/MM/yyyy HH:mm"
                                showTimeSelect timeFormat="HH:mm" timeIntervals={30}
                                selectsStart // Indicate start date
                                startDate={formData.pickupDate}
                                endDate={formData.dropoffDate}
                                placeholderText="Select Pick-up"
                                open={datePickerOpen.pickup}
                                onClickOutside={() => { if (dateTimeComplete.pickup || !formData.pickupDate) { setDatePickerOpen(prev => ({ ...prev, pickup: false })); if (dateTimeComplete.pickup) setTimeWarnings(prev => ({ ...prev, pickup: false })); } else { setTimeWarnings(prev => ({ ...prev, pickup: true })); } }}
                                wrapperClassName="w-full"
                                onInputClick={() => setDatePickerOpen(prev => ({ ...prev, pickup: true, dropoff: false }))} // Close other picker
                                renderDayContents={renderDayContents}
                                disabled={!selectedCar}
                                popperPlacement="bottom-start"
                                required // HTML5 validation
                                aria-required="true"
                                aria-describedby="pickupDateError pickupTimeWarning" // Accessibility
                              />
                              {errors.pickupDate && <p id="pickupDateError" className="text-red-600 text-xs mt-1">{errors.pickupDate}</p>}
                              {timeWarnings.pickup && !dateTimeComplete.pickup && <p id="pickupTimeWarning" className="text-yellow-600 text-xs mt-1">Please select a time.</p>}
                            </div>
                            {/* Dropoff Date */}
                            <div>
                              <label htmlFor="dropoffDate" className="block text-sm font-medium text-gray-600 mb-1">
                                Drop-off Date & Time *
                                <span className="ml-2 text-xs text-blue-600 bg-blue-50 px-2 py-1 rounded">
                                  Athens Time (GMT+2/+3)
                                </span>
                              </label>
                              <p className="text-xs text-gray-500 mb-2">
                                Times are shown and stored in Athens timezone, regardless of your location
                              </p>
                              <DatePicker
                                id="dropoffDate"
                                selected={formData.dropoffDate}
                                onChange={(date) => handleDateChange(date, "dropoffDate")}
                                onMonthChange={handleMonthChange}
                                customInput={<CustomInputComponent placeholder="Select Drop-off" isError={!!errors.dropoffDate} icon={FaCalendarAlt} />}
                                dateFormat="dd/MM/yyyy HH:mm"
                                showTimeSelect timeFormat="HH:mm" timeIntervals={30}
                                minDate={formData.pickupDate} // Min dropoff is pickup date
                                filterTime={(time) => { /* Filter times logic */
                                    if (!formData.pickupDate) return true;
                                    const pickupD = new Date(formData.pickupDate);
                                    // Create a date object for the time being filtered, using the selected dropoff date
                                    const currentDropoffDate = formData.dropoffDate || new Date(); // Use current date if dropoff isn't set yet for comparison basis
                                    const timeToCheck = new Date(currentDropoffDate);
                                    timeToCheck.setHours(time.getHours(), time.getMinutes(), 0, 0);

                                    if (timeToCheck.toDateString() === pickupD.toDateString()) {
                                        return timeToCheck.getTime() > pickupD.getTime(); // Allow times strictly after pickup time
                                    }
                                    return true; // Allow all times on subsequent days
                                }}
                                selectsEnd // Indicate end date
                                startDate={formData.pickupDate}
                                endDate={formData.dropoffDate}
                                placeholderText="Select Drop-off"
                                open={datePickerOpen.dropoff}
                                onClickOutside={() => { if (dateTimeComplete.dropoff || !formData.dropoffDate) { setDatePickerOpen(prev => ({ ...prev, dropoff: false })); if (dateTimeComplete.dropoff) setTimeWarnings(prev => ({ ...prev, dropoff: false })); } else { setTimeWarnings(prev => ({ ...prev, dropoff: true })); } }}
                                wrapperClassName="w-full"
                                onInputClick={() => setDatePickerOpen(prev => ({ ...prev, dropoff: true, pickup: false }))} // Close other picker
                                renderDayContents={renderDayContents}
                                disabled={!selectedCar || !formData.pickupDate} // Disable until pickup is set
                                popperPlacement="bottom-start"
                                required
                                aria-required="true"
                                aria-describedby="dropoffDateError dropoffTimeWarning"
                              />
                              {errors.dropoffDate && <p id="dropoffDateError" className="text-red-600 text-xs mt-1">{errors.dropoffDate}</p>}
                              {timeWarnings.dropoff && !dateTimeComplete.dropoff && <p id="dropoffTimeWarning" className="text-yellow-600 text-xs mt-1">Please select a time.</p>}
                            </div>
                          </div>
                        </div>

                        {/* --- Locations --- */}
                                    <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
                                      <div className="flex justify-between items-center mb-3">
                                       <h4 className="font-medium text-gray-700 text-base flex items-center"><FaMapMarkerAlt className="mr-2 text-gray-500"/> Locations</h4>
                                       <label className="flex items-center text-xs sm:text-sm text-gray-600 cursor-pointer">
                                        <input type="checkbox" checked={sameLocation}
                                          onChange={(e) => { /* Same location logic */
                                            const isChecked = e.target.checked;
                                            setSameLocation(isChecked);
                                            if (isChecked) {
                                              setFormData((prev) => ({ ...prev, dropoffLocation: prev.pickupLocation, customDropoffLocation: prev.customPickupLocation }));
                                              setErrors(prev => ({ ...prev, dropoffLocation: undefined })); // Clear dropoff error
                                            } else {
                                              setFormData((prev) => ({ ...prev, dropoffLocation: "", customDropoffLocation: "" })); // Clear dropoff when unchecked
                                            }
                                          }}
                                          className="mr-1.5 sm:mr-2 w-4 h-4 rounded text-blue-600 focus:ring-blue-500 border-gray-300"
                                          disabled={!selectedCar}
                                        />
                                        <span className="whitespace-nowrap">Same return location</span>
                                       </label>
                                      </div>
                                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                      {/* Pickup Location */}
                                      <div>
                                        <label htmlFor="pickupLocation" className="block text-sm font-medium text-gray-600 mb-1">Pick-up Location *</label>
                                        <CustomSelect id="pickupLocation" 
                                        value={formData.pickupLocation || (isPartnerMode && partner ? "other" : "")}
                                        onChange={(e) => { /* Pickup change logic */
                                          const newValue = e.target.value;
                                          setFormData((prev) => ({ ...prev, pickupLocation: newValue, customPickupLocation: newValue !== "other" ? "" : prev.customPickupLocation, ...(sameLocation ? { dropoffLocation: newValue, customDropoffLocation: newValue !== "other" ? "" : prev.customPickupLocation } : {}) }));
                                          if (newValue) setErrors(prev => ({...prev, pickupLocation: undefined})); // Clear error on selection
                                        }}
                                        onOtherLocationChange={(value) => { /* Custom pickup change */
                                          setFormData((prev) => ({ ...prev, customPickupLocation: value, ...(sameLocation ? { customDropoffLocation: value } : {}) }));
                                           if (value.trim()) setErrors(prev => ({...prev, pickupLocation: undefined})); // Clear error if typing
                                        }}
                                        options={locationOptions} placeholder="Select pick-up location"
                                        showOtherInput={true} 
                                        initialCustomValue={formData.customPickupLocation || (isPartnerMode && partner ? partner.firstName : "")}
                                        disabled={!selectedCar} required
                                        />
                                        {errors.pickupLocation && <p className="text-red-600 text-xs mt-1">{errors.pickupLocation}</p>}
                                      </div>
                                      {/* Dropoff Location (Conditional) */}
                                      <div className={`${sameLocation ? 'hidden' : 'block'}`}>
                                        <label htmlFor="dropoffLocation" className="block text-sm font-medium text-gray-600 mb-1">Drop-off Location *</label>
                                        <CustomSelect id="dropoffLocation" 
                                        value={formData.dropoffLocation || (isPartnerMode && partner ? "other" : "")}
                                        onChange={(e) => { /* Dropoff change logic */
                                          const newValue = e.target.value;
                                          setFormData((prev) => ({ ...prev, dropoffLocation: newValue, customDropoffLocation: newValue !== "other" ? "" : prev.customDropoffLocation }));
                                           if (newValue) setErrors(prev => ({...prev, dropoffLocation: undefined})); // Clear error
                                        }}
                                        onOtherLocationChange={(value) => { /* Custom dropoff change */
                                          setFormData((prev) => ({ ...prev, customDropoffLocation: value }));
                                           if (value.trim()) setErrors(prev => ({...prev, dropoffLocation: undefined})); // Clear error
                                        }}
                                        options={locationOptions} placeholder="Select drop-off location"
                                        showOtherInput={true} 
                                        initialCustomValue={formData.customDropoffLocation || (isPartnerMode && partner ? partner.firstName : "")}
                                        disabled={!selectedCar || sameLocation} required={!sameLocation} // Required only if different
                                        />
                                        {errors.dropoffLocation && !sameLocation && <p className="text-red-600 text-xs mt-1">{errors.dropoffLocation}</p>}
                                      </div>
                                      </div>
                                    </div>

                                    {/* --- Customer Information --- */}
                        <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
                           <h4 className="font-medium text-gray-700 mb-3 text-base flex items-center"><FaUser className="mr-2 text-gray-500"/> Customer Information</h4>
                           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {/* First Name */}
                            <div>
                                <label htmlFor="firstName" className="block text-sm font-medium text-gray-600 mb-1">First Name *</label>
                                <input id="firstName" type="text" placeholder="Enter first name" value={formData.firstName}
                                onChange={(e) => { setFormData({ ...formData, firstName: e.target.value }); if (e.target.value.trim()) setErrors(prev => ({...prev, firstName: undefined})); }}
                                disabled={!selectedCar} required
                                className={`w-full px-3 py-2 border ${errors.firstName ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-300 focus:ring-blue-500 focus:border-blue-500'} rounded-md transition-colors ${!selectedCar ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                                />
                                {errors.firstName && <p className="text-red-600 text-xs mt-1">{errors.firstName}</p>}
                            </div>
                            {/* Last Name */}
                            <div>
                                <label htmlFor="lastName" className="block text-sm font-medium text-gray-600 mb-1">Last Name *</label>
                                <input id="lastName" type="text" placeholder="Enter last name" value={formData.lastName}
                                onChange={(e) => { setFormData({ ...formData, lastName: e.target.value }); if (e.target.value.trim()) setErrors(prev => ({...prev, lastName: undefined})); }}
                                disabled={!selectedCar} required
                                className={`w-full px-3 py-2 border ${errors.lastName ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-300 focus:ring-blue-500 focus:border-blue-500'} rounded-md transition-colors ${!selectedCar ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                                />
                                {errors.lastName && <p className="text-red-600 text-xs mt-1">{errors.lastName}</p>}
                            </div>
                            {/* Email */}
                            <div>
                                <label htmlFor="email" className="block text-sm font-medium text-gray-600 mb-1">Email Address *</label>
                                <input id="email" type="email" placeholder="Enter email address" value={formData.email}
                                onChange={(e) => { setFormData({ ...formData, email: e.target.value }); if (/\S+@\S+\.\S+/.test(e.target.value)) setErrors(prev => ({...prev, email: undefined})); }}
                                disabled={!selectedCar} required
                                className={`w-full px-3 py-2 border ${errors.email ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-300 focus:ring-blue-500 focus:border-blue-500'} rounded-md transition-colors ${!selectedCar ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                                />
                                {errors.email && <p className="text-red-600 text-xs mt-1">{errors.email}</p>}
                            </div>
                            {/* Phone */}
                            <div>
                              <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                                Phone Number *
                              </label>
                              <div className="relative">
                                <PhoneInput
                                  international
                                  defaultCountry="GR"
                                  value={formData.phone}
                                  onChange={(value) => {
                                    setFormData({
                                      ...formData,
                                      phone: value,
                                    });
                                  }}
                                  placeholder="Phone number with country code"
                                  autoComplete="on"
                                  disabled={!selectedCar}
                                  className={`w-full border border-gray-300 p-2 ${
                                    errors.phone ? "border-red-500" : "border-gray-300"
                                  } rounded-md transition-all hover:border-blue-500 ${
                                    !selectedCar ? "bg-gray-100 cursor-not-allowed opacity-70" : ""
                                  }`}
                                />
                                {errors.phone && (
                                  <p className="text-red-500 text-xs mt-1">
                                    {errors.phone}
                                  </p>
                                )}
                              </div>
                            </div>
                            {/* Age */}
                            <div>
                                <label htmlFor="age" className="block text-sm font-medium text-gray-600 mb-1">Age *</label>
                                <select id="age" value={formData.age}
                                onChange={(e) => { setFormData({ ...formData, age: e.target.value }); if (e.target.value) setErrors(prev => ({...prev, age: undefined})); }}
                                disabled={!selectedCar} required
                                className={`w-full h-10 px-3 border ${errors.age ? 'border-red-500' : 'border-gray-300'} rounded bg-white appearance-none hover:border-blue-500 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 ${!selectedCar ? 'bg-gray-100 cursor-not-allowed opacity-70' : ''}`}
                                >
                                    <option value="" disabled>Select age</option>
                                    {Array.from({ length: 9 }, (_, i) => 18 + i).map((age) => (
                                    <option key={age} value={age}>{age} years old</option>
                                    ))}
                                    <option value="26+">26+ years old</option>
                                </select>
                                {errors.age && <p className="text-red-600 text-xs mt-1">{errors.age}</p>}
                            </div>
                           </div>
                        </div>

                        {/* --- Payment Method Section --- */}
                        <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
                          <h4 className="font-medium text-gray-700 mb-3 text-base flex items-center">
                            <FaCreditCard className="mr-2 text-gray-500" />
                            Payment Method
                          </h4>
                          
                          {loadingPaymentMethods ? (
                            <div className="flex justify-center py-4">
                              <LoadingSpinner size="sm" />
                              <span className="ml-2 text-sm text-gray-500">Loading payment methods...</span>
                            </div>
                          ) : (
                            <div className="space-y-2">
                              {paymentMethods.length > 0 ? (
                                paymentMethods.filter(method => method.status).map((method) => {
                                  // Get payment method icon based on English title
                                  const getPaymentIcon = (title) => {
                                    switch (title) {
                                      case 'Cash': return '💰';
                                      case 'Credit Card': return '💳';
                                      case 'Bank Deposit / Transfer': return '🏦';
                                      case 'PayPal': return '🅿️';
                                      case 'Check': return '📋';
                                      case 'Other': return '💼';
                                      default: return '💼';
                                    }
                                  };

                                  return (
                                    <label
                                      key={method.id}
                                      className={`flex items-center p-3 border rounded-lg cursor-pointer transition-all duration-200 ${
                                        formData.paymentMethod === method.id
                                          ? "border-blue-500 bg-blue-50"
                                          : "border-gray-200 hover:border-blue-300 hover:bg-gray-50"
                                      }`}
                                    >
                                      <input
                                        type="radio"
                                        name="paymentMethod"
                                        value={method.id}
                                        checked={formData.paymentMethod === method.id}
                                        onChange={(e) => {
                                          setFormData({ ...formData, paymentMethod: e.target.value });
                                          setErrors(prev => ({ ...prev, paymentMethod: undefined }));
                                        }}
                                        className="hidden"
                                        disabled={!selectedCar}
                                      />
                                      <div className={`w-4 h-4 rounded-full border-2 mr-3 flex-shrink-0 transition-all duration-200 ${
                                        formData.paymentMethod === method.id
                                          ? "border-blue-500 bg-blue-500"
                                          : "border-gray-300"
                                      }`}>
                                        {formData.paymentMethod === method.id && (
                                          <div className="w-full h-full rounded-full bg-white scale-50" />
                                        )}
                                      </div>
                                      <div className="flex-1">
                                        <span className="font-medium text-gray-800 text-sm">
                                          {method.title_en}
                                        </span>
                                        {method.title_gr && method.title_gr !== method.title_en && (
                                          <span className="text-xs text-gray-500 ml-1">
                                            ({method.title_gr})
                                          </span>
                                        )}
                                      </div>
                                      <span className="text-lg ml-2">
                                        {getPaymentIcon(method.title_en)}
                                      </span>
                                    </label>
                                  );
                                })
                              ) : (
                                <div className="p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                                  <p className="text-yellow-700 text-sm">
                                    Payment methods are being loaded. Please wait...
                                  </p>
                                </div>
                              )}
                              
                              {errors.paymentMethod && (
                                <p 
                                  className="text-red-500 text-xs mt-1"
                                  data-error="true"
                                >
                                  {errors.paymentMethod}
                                </p>
                              )}
                            </div>
                          )}
                          
                          <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mt-3">
                            <p className="text-blue-700 text-xs">
                              <strong>Note:</strong> Payment will be processed upon vehicle pickup. 
                              We accept cash, major credit cards, and bank transfers.
                            </p>
                          </div>
                        </div>

                        {/* --- Additional Options & Coupon --- */}
                        <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
                          <h4 className="font-medium text-gray-700 mb-3 text-base">Additional Options & Discounts</h4>
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {/* Options */}
                            <div>
                              <p className="text-sm font-medium text-gray-600 mb-2">Additional Options:</p>
                              <div className="space-y-1">
                                {loadingAdditionalOptions ? (
                                  <div className="flex items-center justify-center p-4">
                                    <LoadingSpinner size="sm" />
                                    <span className="ml-2 text-sm text-gray-500">Loading options...</span>
                                  </div>
                                ) : additionalOptionsData.length > 0 ? (
                                  additionalOptionsData.map((option) => (
                                    <div key={option._id} className="relative group">
                                      <CustomCheckbox
                                        id={`option-${option._id}`}
                                        checked={formData.additionalOptions[option._id] || false}
                                        onChange={(e) =>
                                          setFormData(prev => ({
                                            ...prev,
                                            additionalOptions: {
                                              ...prev.additionalOptions,
                                              [option._id]: e.target.checked,
                                            },
                                          }))
                                        }
                                        label={`${option.name}${option.price > 0 ? ` (€${option.price.toFixed(2)}/day)` : ' (Free)'}`}
                                      />
                                      {/* Tooltip for description */}
                                      <div className="absolute left-0 bottom-full mb-2 w-48 bg-gray-800 text-white text-xs rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10">
                                        {option.description}
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <div className="text-gray-500 text-sm italic">No additional options available</div>
                                )}
                              </div>
                              
                              {/* NEW: Advanced Payment Section */}
                                <div className="mt-4 pt-4 border-t border-gray-200">
                                  <label htmlFor="advancePayment" className="block text-sm font-medium text-gray-600 mb-1">Advanced Payment (€)</label>
                                  <div className="relative">
                                    <input
                                      id="advancePayment"
                                      type="number"
                                      min="0"
                                      step="0.01"
                                      placeholder="Amount already paid"
                                      value={formData.advancePayment}
                                      onChange={(e) => {
                                        // Validate as user types
                                        const value = e.target.value;
                                        setFormData(prev => ({ ...prev, advancePayment: value }));
                                        
                                        // Clear error when field is emptied
                                        if (!value) {
                                          setErrors(prev => ({ ...prev, advancePayment: undefined }));
                                        }
                                      }}
                                      onBlur={() => {
                                        // Validate on blur
                                        if (formData.advancePayment) {
                                          const advancePayment = parseFloat(formData.advancePayment);
                                          if (isNaN(advancePayment) || advancePayment < 0) {
                                            setErrors(prev => ({ ...prev, advancePayment: "Must be a positive number" }));
                                          } else if (advancePayment > totalPrice) {
                                            setErrors(prev => ({ ...prev, advancePayment: "Cannot exceed total price" }));
                                          } else {
                                            setErrors(prev => ({ ...prev, advancePayment: undefined }));
                                          }
                                        }
                                      }}
                                      disabled={!selectedCar || !formData.pickupDate || !formData.dropoffDate || totalPrice <= 0}
                                      className={`w-full px-3 py-2 border ${
                                        errors.advancePayment ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-300 focus:ring-blue-500 focus:border-blue-500'
                                      } rounded-md transition-colors ${
                                        !selectedCar || !formData.pickupDate || !formData.dropoffDate || totalPrice <= 0 ? 'bg-gray-100 cursor-not-allowed opacity-70' : ''
                                      }`}
                                    />
                                    {errors.advancePayment && (
                                      <p className="text-red-600 text-xs mt-1">{errors.advancePayment}</p>
                                    )}
                                    <p className="text-xs text-gray-500 mt-1">
                                      {totalPrice > 0 
                                        ? `Enter amount already paid (max: €${totalPrice.toFixed(2)})`
                                        : 'Select car and dates to enable'
                                      }
                                    </p>
                                  </div>
                                </div>
                            </div>
                            {/* Coupon */}
                            <div>
                                <label htmlFor="couponCode" className="block text-sm font-medium text-gray-600 mb-1">Coupon Code</label>
                                <div className="relative">
                                    <input id="couponCode" type="text" placeholder="Enter coupon code" value={formData.couponCode}
                                    onChange={(e) => { const code = e.target.value.toUpperCase(); setFormData({ ...formData, couponCode: code }); setCouponStatus(prev => ({ ...prev, message: '' })); }}
                                    onBlur={() => validateCoupon(formData.couponCode)}
                                    disabled={!selectedCar || !formData.pickupDate || !formData.dropoffDate}
                                    className={`w-full px-3 py-2 border rounded-md transition-colors ${couponStatus.isValid ? 'border-green-500 focus:ring-green-500 focus:border-green-500' : couponStatus.message ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-300 focus:ring-blue-500 focus:border-blue-500 hover:border-blue-500'} ${!selectedCar || !formData.pickupDate || !formData.dropoffDate ? 'bg-gray-100 cursor-not-allowed opacity-70' : ''}`}
                                    />
                                    <AnimatePresence>
                                    {couponStatus.message && (
                                        <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }}
                                        className={`text-xs mt-1 overflow-hidden ${couponStatus.isValid ? 'text-green-600' : 'text-red-600'}`} >
                                            {couponStatus.message}
                                        </motion.div>
                                    )}
                                    </AnimatePresence>
                                </div>
                            </div>
                          </div>
                          {/* Notes */}
                          <div className="mt-4">
                            <label htmlFor="notes" className="block text-sm font-medium text-gray-600 mb-1">Additional Notes:</label>
                            <textarea id="notes" value={formData.notes}
                                onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
                                rows="3" disabled={!selectedCar}
                                className={`w-full p-3 border border-gray-300 rounded bg-white hover:border-blue-500 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 ${!selectedCar ? 'bg-gray-100 cursor-not-allowed opacity-70' : ''}`}
                                placeholder="e.g., Flight number, specific delivery instructions..."
                            />
                          </div>
                        </div>

                        {/* --- Invoice Section (Admin) --- */}
                        <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
                          <h4 className="font-medium text-gray-700 mb-3 text-base">Invoice Information</h4>
                          
                          {/* Invoice Toggle */}
                          <div className="mb-4">
                            <CustomCheckbox
                              id="wantsInvoice"
                              checked={wantsInvoice}
                              onChange={(e) => {
                                setWantsInvoice(e.target.checked);
                                if (!e.target.checked) {
                                  // Clear invoice errors when unchecked
                                  setErrors(prev => {
                                    const newErrors = { ...prev };
                                    delete newErrors.companyName;
                                    delete newErrors.vatNumber;
                                    delete newErrors.address;
                                    delete newErrors.city;
                                    delete newErrors.postalCode;
                                    return newErrors;
                                  });
                                }
                              }}
                              label="Customer wants invoice"
                              disabled={!selectedCar}
                            />
                          </div>

                          {/* Invoice Form Fields */}
                          <AnimatePresence>
                            {wantsInvoice && (
                              <motion.div
                                initial={{ opacity: 0, height: 0 }}
                                animate={{ opacity: 1, height: "auto" }}
                                exit={{ opacity: 0, height: 0 }}
                                transition={{ duration: 0.3 }}
                                className="overflow-hidden"
                              >
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4 border-t border-gray-200">
                                  {/* Company Name */}
                                  <div>
                                    <label htmlFor="companyName" className="block text-sm font-medium text-gray-600 mb-1">
                                      Company Name *
                                    </label>
                                    <input
                                      id="companyName"
                                      type="text"
                                      placeholder="Enter company name"
                                      value={invoiceData.companyName}
                                      onChange={(e) => {
                                        setInvoiceData(prev => ({ ...prev, companyName: e.target.value }));
                                        if (e.target.value.trim()) {
                                          setErrors(prev => ({ ...prev, companyName: undefined }));
                                        }
                                      }}
                                      className={`w-full px-3 py-2 border ${
                                        errors.companyName ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-300 focus:ring-blue-500 focus:border-blue-500'
                                      } rounded-md transition-colors`}
                                      data-error={!!errors.companyName}
                                    />
                                    {errors.companyName && (
                                      <p className="text-red-600 text-xs mt-1">{errors.companyName}</p>
                                    )}
                                  </div>

                                  {/* VAT Number */}
                                  <div>
                                    <label htmlFor="vatNumber" className="block text-sm font-medium text-gray-600 mb-1">
                                      VAT Number *
                                    </label>
                                    <input
                                      id="vatNumber"
                                      type="text"
                                      placeholder="Enter VAT number"
                                      value={invoiceData.vatNumber}
                                      onChange={(e) => {
                                        setInvoiceData(prev => ({ ...prev, vatNumber: e.target.value }));
                                        if (e.target.value.trim()) {
                                          setErrors(prev => ({ ...prev, vatNumber: undefined }));
                                        }
                                      }}
                                      className={`w-full px-3 py-2 border ${
                                        errors.vatNumber ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-300 focus:ring-blue-500 focus:border-blue-500'
                                      } rounded-md transition-colors`}
                                      data-error={!!errors.vatNumber}
                                    />
                                    {errors.vatNumber && (
                                      <p className="text-red-600 text-xs mt-1">{errors.vatNumber}</p>
                                    )}
                                  </div>

                                  {/* Address */}
                                  <div className="md:col-span-2">
                                    <label htmlFor="invoiceAddress" className="block text-sm font-medium text-gray-600 mb-1">
                                      Address *
                                    </label>
                                    <input
                                      id="invoiceAddress"
                                      type="text"
                                      placeholder="Enter company address"
                                      value={invoiceData.address}
                                      onChange={(e) => {
                                        setInvoiceData(prev => ({ ...prev, address: e.target.value }));
                                        if (e.target.value.trim()) {
                                          setErrors(prev => ({ ...prev, address: undefined }));
                                        }
                                      }}
                                      className={`w-full px-3 py-2 border ${
                                        errors.address ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-300 focus:ring-blue-500 focus:border-blue-500'
                                      } rounded-md transition-colors`}
                                      data-error={!!errors.address}
                                    />
                                    {errors.address && (
                                      <p className="text-red-600 text-xs mt-1">{errors.address}</p>
                                    )}
                                  </div>

                                  {/* City */}
                                  <div>
                                    <label htmlFor="invoiceCity" className="block text-sm font-medium text-gray-600 mb-1">
                                      City *
                                    </label>
                                    <input
                                      id="invoiceCity"
                                      type="text"
                                      placeholder="Enter city"
                                      value={invoiceData.city}
                                      onChange={(e) => {
                                        setInvoiceData(prev => ({ ...prev, city: e.target.value }));
                                        if (e.target.value.trim()) {
                                          setErrors(prev => ({ ...prev, city: undefined }));
                                        }
                                      }}
                                      className={`w-full px-3 py-2 border ${
                                        errors.city ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-300 focus:ring-blue-500 focus:border-blue-500'
                                      } rounded-md transition-colors`}
                                      data-error={!!errors.city}
                                    />
                                    {errors.city && (
                                      <p className="text-red-600 text-xs mt-1">{errors.city}</p>
                                    )}
                                  </div>

                                  {/* Postal Code */}
                                  <div>
                                    <label htmlFor="postalCode" className="block text-sm font-medium text-gray-600 mb-1">
                                      Postal Code *
                                    </label>
                                    <input
                                      id="postalCode"
                                      type="text"
                                      placeholder="Enter postal code"
                                      value={invoiceData.postalCode}
                                      onChange={(e) => {
                                        setInvoiceData(prev => ({ ...prev, postalCode: e.target.value }));
                                        if (e.target.value.trim()) {
                                          setErrors(prev => ({ ...prev, postalCode: undefined }));
                                        }
                                      }}
                                      className={`w-full px-3 py-2 border ${
                                        errors.postalCode ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-300 focus:ring-blue-500 focus:border-blue-500'
                                      } rounded-md transition-colors`}
                                      data-error={!!errors.postalCode}
                                    />
                                    {errors.postalCode && (
                                      <p className="text-red-600 text-xs mt-1">{errors.postalCode}</p>
                                    )}
                                  </div>

                                  {/* Country */}
                                  <div className="md:col-span-2">
                                    <label htmlFor="country" className="block text-sm font-medium text-gray-600 mb-1">
                                      Country
                                    </label>
                                    <input
                                      id="country"
                                      type="text"
                                      placeholder="Enter country"
                                      value={invoiceData.country}
                                      onChange={(e) => setInvoiceData(prev => ({ ...prev, country: e.target.value }))
                                      }
                                      className="w-full px-3 py-2 border border-gray-300 rounded-md transition-colors focus:ring-blue-500 focus:border-blue-500"
                                    />
                                  </div>
                                </div>
                              </motion.div>
                            )}
                          </AnimatePresence>
                        </div>

                        {/* --- Price Breakdown (MODIFIED for Advanced Payment) --- */}
                        <div className="bg-gradient-to-br from-blue-900 to-blue-700 p-4 rounded-lg shadow-lg text-white">
                          <h4 className="font-medium text-white mb-4 flex items-center"><FaMoneyBillWave className="mr-2" /> Price Breakdown</h4>

                          {/* --- Custom Price Input Section --- */}
                          <div className="mb-4 border-b border-blue-600 pb-3">
                            <div className="flex justify-between items-center mb-1">
                              <label htmlFor="customPrice" className="block text-sm text-gray-200">Custom Price Per Day (Admin Only)</label>
                              {formData.customPricePerDay && (
                                <button type="button" onClick={() => setFormData(prev => ({ ...prev, customPricePerDay: "" }))}
                                  className="text-xs text-blue-300 hover:text-blue-100 underline focus:outline-none focus:ring-1 focus:ring-blue-300 rounded px-1">
                                  Clear Custom Price
                                </button>
                              )}
                            </div>
                            <div className="flex items-center">
                              <span className="text-white text-lg mr-2">€</span>
                              <input id="customPrice" type="number" value={formData.customPricePerDay}
                                onChange={(e) => setFormData(prev => ({ ...prev, customPricePerDay: e.target.value }))}
                                min="0" step="0.01" placeholder="Enter custom daily rate"
                                disabled={!selectedCar || !formData.pickupDate || !formData.dropoffDate}
                                className={`w-full bg-blue-800 border border-blue-600 text-white px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 ${(!selectedCar || !formData.pickupDate || !formData.dropoffDate) ? 'opacity-50 cursor-not-allowed' : ''}`}
                              />
                            </div>
                            <p className="text-xs text-blue-300 mt-1">Overrides default/dynamic prices if set.</p>
                            {/* Display calculated total based on custom price */}
                            {formData.pickupDate && formData.dropoffDate && formData.customPricePerDay && parseFloat(formData.customPricePerDay) > 0 && !isNaN(parseFloat(formData.customPricePerDay)) && (
                              <div className="mt-2 bg-blue-800/50 p-2 rounded border border-blue-600/50">
                                <div className="flex justify-between items-center text-sm">
                                  <span className="text-blue-200">Base total (custom):</span>
                                  <span className="font-semibold text-white">
                                    €{(() => {
                                      const diffTime = Math.abs(new Date(formData.dropoffDate) - new Date(formData.pickupDate));
                                      const days = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                                      const customPrice = parseFloat(formData.customPricePerDay);
                                      return (customPrice * days).toFixed(2);
                                    })()}
                                  </span>
                                </div>
                                <div className="flex justify-between items-center text-xs text-blue-300 mt-1">
                                  <span>For {Math.ceil(Math.abs(new Date(formData.dropoffDate) - new Date(formData.pickupDate)) / (1000 * 60 * 60 * 24))} day(s)</span>
                                  <span>(Before discounts & VAT)</span>
                                </div>
                              </div>
                            )}
                          </div>
                          {/* --- End Custom Price Input --- */}

                          {/* Detailed Breakdown */}
                          <div className="space-y-1 text-sm mb-3">
                            {formData.pickupDate && formData.dropoffDate && selectedCar ? (
                              calculatePriceBreakdown()?.length > 0 ? (
                                calculatePriceBreakdown().map((period, index) => (
                                  <div key={index} className="flex justify-between items-center">
                                    <span className="text-gray-300">
                                      {period.days > 1 ? `${formatDateRange(period.startDate)} - ${formatDateRange(period.endDate)}` : formatDateRange(period.startDate)}
                                      {` (${period.days} day${period.days > 1 ? "s" : ""})`}
                                    </span>
                                    <span className={`font-medium ${formData.customPricePerDay && parseFloat(formData.customPricePerDay) > 0 && !isNaN(parseFloat(formData.customPricePerDay)) ? 'text-yellow-300' : period.price !== selectedCar.basePrice ? 'text-blue-300' : 'text-gray-100'}`}>
                                      €{period.price.toFixed(2)}/day
                                      {formData.customPricePerDay && parseFloat(formData.customPricePerDay) > 0 && !isNaN(parseFloat(formData.customPricePerDay)) && index === 0 && <span className="text-xs ml-1">(Custom)</span>}
                                    </span>
                                  </div>
                                ))
                              ) : <p className="text-center text-blue-200 py-2">Calculating price...</p>
                            ) : <p className="text-center text-blue-200 py-2">Select car and dates.</p>}
                          </div>

                          {/* Totals Section */}
                          {formData.pickupDate && formData.dropoffDate && selectedCar && calculatePriceBreakdown()?.length > 0 && (
                            <div className="mt-4 pt-3 border-t border-blue-600 space-y-1.5 text-sm">
                              {/* Duration Discount */}
                              {(() => { /* Duration discount calculation */
                                const diffTime = Math.abs(new Date(formData.dropoffDate) - new Date(formData.pickupDate));
                                const days = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                                let discountPercentage = 0;
                                if (days > 10 && durationDiscounts.longTerm?.discount) discountPercentage = durationDiscounts.longTerm.discount;
                                else if (days > 3 && durationDiscounts.mediumTerm?.discount) discountPercentage = durationDiscounts.mediumTerm.discount;
                                else if (durationDiscounts.shortTerm?.discount) discountPercentage = durationDiscounts.shortTerm.discount;

                                if (discountPercentage > 0) {
                                  const subtotalBeforeDiscounts = calculatePriceBreakdown()?.reduce((total, period) => total + period.price * period.days, 0) || 0;
                                  const durationDiscountAmount = (subtotalBeforeDiscounts * discountPercentage) / 100;
                                  return (
                                    <div className="flex justify-between items-center text-green-300">
                                      <span>Duration Discount ({discountPercentage}%):</span>
                                      <span>-€{durationDiscountAmount.toFixed(2)}</span>
                                    </div>
                                  );
                                } return null;
                              })()}
                              {/* Subtotal */}
                              <div className="flex justify-between items-center text-gray-200">
                                <span>Subtotal (before VAT):</span>
                                <span>€{(totalPrice / 1.24 + (couponStatus.isValid ? couponStatus.discount : 0)).toFixed(2)}</span>
                              </div>
                              {/* Coupon Discount */}
                              {couponStatus.isValid && (
                                <div className="flex justify-between items-center text-green-300">
                                  <span>Coupon Discount:</span>
                                  <span>-€{couponStatus.discount.toFixed(2)}</span>
                                </div>
                              )}
                              {/* Net Total */}
                              <div className="flex justify-between items-center text-gray-100 font-medium">
                                <span>Net Total (before VAT):</span>
                                <span>€{(totalPrice / 1.24).toFixed(2)}</span>
                              </div>
                              {/* VAT */}
                              <div className="flex justify-between items-center text-gray-200">
                                <span>VAT (24%):</span>
                                <span>€{(totalPrice - totalPrice / 1.24).toFixed(2)}</span>
                              </div>
                              {/* Grand Total */}
                              <div className="flex justify-between items-center font-bold text-lg mt-3 pt-3 border-t border-blue-600">
                                <span>Total:</span>
                                <span>€{totalPrice.toFixed(2)}</span>
                              </div>
                              
                              {/* NEW: Advanced Payment Display */}
                              {formData.advancePayment && parseFloat(formData.advancePayment) > 0 && (
                                <>
                                  <div className="flex justify-between items-center text-yellow-300 mt-2">
                                    <span>Advanced Payment:</span>
                                    <span>-€{parseFloat(formData.advancePayment).toFixed(2)}</span>
                                  </div>
                                  <div className="flex justify-between items-center font-bold bg-blue-800 mt-2 p-2 rounded">
                                    <span>Balance Due:</span>
                                    <span>€{Math.max(0, totalPrice - parseFloat(formData.advancePayment)).toFixed(2)}</span>
                                  </div>
                                </>
                              )}
                            </div>
                          )}
                        </div>

                        {/* --- Submission Area --- */}
                        <div className="mt-6 flex flex-col items-end">
                            {/* Submission Error Message */}
                            {errors.submit && (
                                <div id="submission-error" className="w-full bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-3" role="alert">
                                <strong className="font-bold">Error: </strong>
                                <span className="block sm:inline">{errors.submit}</span>
                                </div>
                            )}
                            {/* Submit Button */}
                            <button type="submit"
                                disabled={loading || !selectedCar || !formData.pickupDate || !formData.dropoffDate || Object.values(errors).some(e => e)} // Disable if loading or errors exist
                                className="px-6 py-2.5 bg-blue-800 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-150 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2 shadow-md hover:shadow-lg min-w-[150px]" // Min width for button
                            >
                                {loading ? (
                                <>
                                    <LoadingSpinner size="sm" className="text-white" />
                                    <span>Creating...</span>
                                </>
                                ) : (
                                <>
                                    <FaCarSide className="mr-1"/>
                                    <span>Create Rental</span>
                                </>
                                )}
                            </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* --- Datepicker Styles --- */}
        <style jsx="true">{`
          .react-datepicker-popper { z-index: 60 !important; }
          .react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range { background-color: #1e40af !important; color: white !important; border-radius: 0.375rem; } /* Tailwind blue-800 */
          .react-datepicker__day--selected:hover, .react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover { background-color: #1d4ed8 !important; } /* Tailwind blue-700 */
          .react-datepicker__time-list-item--selected { background-color: #1e40af !important; color: white !important; }
          .react-datepicker__time-list-item--selected:hover { background-color: #1d4ed8 !important; }
          .react-datepicker__day { position: relative; padding-bottom: 14px !important; /* More space for price */ height: 2rem; /* Consistent height */}
          .react-datepicker__day > div > div { /* Price display */
            position: absolute; bottom: 1px; left: 0; right: 0; line-height: 1; padding: 0 1px;
          }
          .react-datepicker { font-size: 0.8rem !important; /* Slightly smaller datepicker */ }
        `}</style>
      </motion.div>
    </div>
  );
};

export default CreateRentalModal;
